// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import {
//   Button, Slider, InputNumber, Switch, Divider, Tooltip,
//   message, Typography, Space, Spin, Tag, Grid,
// } from 'antd';
// import {
//   SaveOutlined, ReloadOutlined, EyeOutlined, EyeInvisibleOutlined,
// } from '@ant-design/icons';

// const { Title, Text } = Typography;
// const { useBreakpoint } = Grid;

// // ── Firestore REST ────────────────────────────────────────────────────────
// const PROJECT_ID = 'portfolio-e79b8-5854c';
// const API_KEY    = 'AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc';
// const REST_BASE  = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents`;
// const DOC_PATH   = `${REST_BASE}/imageConfig/tools?key=${API_KEY}`;

// function toValue(v) {
//   if (v === null || v === undefined) return { nullValue: null };
//   if (typeof v === 'boolean')  return { booleanValue: v };
//   if (typeof v === 'number')   return Number.isInteger(v) ? { integerValue: String(v) } : { doubleValue: v };
//   if (typeof v === 'string')   return { stringValue: v };
//   if (Array.isArray(v))        return { arrayValue: { values: v.map(toValue) } };
//   if (typeof v === 'object')   return { mapValue: { fields: toFields(v) } };
//   return { stringValue: String(v) };
// }
// function toFields(obj) {
//   const out = {};
//   for (const [k, v] of Object.entries(obj)) out[k] = toValue(v);
//   return out;
// }
// function fromValue(v) {
//   if (!v) return null;
//   if ('stringValue'  in v) return v.stringValue;
//   if ('integerValue' in v) return Number(v.integerValue);
//   if ('doubleValue'  in v) return Number(v.doubleValue);
//   if ('booleanValue' in v) return v.booleanValue;
//   if ('nullValue'    in v) return null;
//   if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
//   if ('mapValue'     in v) return fromFields(v.mapValue.fields || {});
//   return null;
// }
// function fromFields(fields) {
//   const obj = {};
//   for (const [k, v] of Object.entries(fields)) obj[k] = fromValue(v);
//   return obj;
// }

// async function loadConfig() {
//   const res = await fetch(DOC_PATH);
//   if (res.status === 404) return null;
//   if (!res.ok) throw new Error(`Firestore GET failed: ${res.status}`);
//   const json = await res.json();
//   return fromFields(json.fields || {});
// }
// async function saveConfig(data) {
//   const fieldPaths = Object.keys(data).map(k => `updateMask.fieldPaths=${encodeURIComponent(k)}`).join('&');
//   const url = `${REST_BASE}/imageConfig/tools?${fieldPaths}&key=${API_KEY}`;
//   const res = await fetch(url, {
//     method: 'PATCH',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ fields: toFields(data) }),
//   });
//   if (!res.ok) throw new Error(`Firestore PATCH failed: ${res.status}`);
//   return res.json();
// }

// // ── Default extra-image object ────────────────────────────────────────────
// const EXTRA_IMAGE_DEFAULTS = {
//   url:               '',
//   hidden:            false,
//   label:             'Extra image',
//   startX_desktop:   -30,
//   startY_desktop:    90,
//   startX_mobile:    -60,
//   startY_mobile:     80,
//   endX_desktop:      95,
//   endY_desktop:     -95,
//   endX_mobile:      100,
//   endY_mobile:      -90,
//   trail:             0.45,
//   img2FadeStart:     0.1,
//   rot2InitOffset:    -18,
//   pA_desktop:        0.22,
//   pB_desktop:        0.62,
//   rot2AtA_desktop:   -40,
//   rot2AtB_desktop:   -30,
//   pA_mobile:         0.48,
//   pB_mobile:         0.52,
//   rot2AtA_mobile:    -60,
//   rot2AtB_mobile:    -60,
//   widthVw_desktop:   20,
//   widthVw_mobile:    44,
//   zIndex:            8,
// };

// // ── Default full config ───────────────────────────────────────────────────
// const DEFAULTS = {
//   textOverline:   'Philosophy',
//   textLine1:      'Craft over',
//   textLine2:      'shortcuts.',
//   textLine3:      'Always.',
//   textLine1Color: '#f0ece4',
//   textLine2Color: 'var(--acid, #c8f04a)',
//   textLine3Color: '#f0ece4',
//   textSub: 'I believe great digital products are built through attention to detail, thoughtful design, and clean engineering. Every project is an opportunity to create experiences that are fast, intuitive, and meaningful. Rather than chasing trends, I focus on building solutions that are reliable, scalable, and crafted to deliver real value.',

//   img1StartX_desktop:   -30,
//   img1StartY_desktop:    90,
//   img1StartRot:         -12,
//   img1EndX_desktop:      95,
//   img1EndY_desktop:     -95,
//   img1EndRot:            10,
//   img1pA_desktop:        0.0,
//   img1pB_desktop:        0.0,
//   img1RotAtA_desktop:   -12,
//   img1RotAtB_desktop:    10,

//   img1StartX_mobile:    -60,
//   img1StartY_mobile:     80,
//   img1EndX_mobile:      100,
//   img1EndY_mobile:      -90,
//   img1pA_mobile:         0.0,
//   img1pB_mobile:         0.0,
//   img1RotAtA_mobile:    -12,
//   img1RotAtB_mobile:     10,

//   trail:                0.38,
//   rot2InitOffset:      -18,
//   pA_desktop:           0.22,
//   pB_desktop:           0.62,
//   rot2AtA_desktop:     -40,
//   rot2AtB_desktop:     -30,
//   pA_mobile:            0.48,
//   pB_mobile:            0.52,
//   rot2AtA_mobile:      -60,
//   rot2AtB_mobile:      -60,

//   pinLength:           220,

//   img1Width_desktop:    24,
//   img1Width_mobile:     52,
//   img2Width_desktop:    20,
//   img2Width_mobile:     44,

//   img1Url: './rock-bg.png',
//   img2Url: './miss.png',

//   img1Hidden: false,
//   img2Hidden: false,

//   extraImages: [],
//   img2FadeStart: 0.1,
// };

// function safeArray(val) { return Array.isArray(val) ? val : []; }
// function mergeExtra(raw) {
//   if (typeof raw === 'string') return { ...EXTRA_IMAGE_DEFAULTS, url: raw };
//   return { ...EXTRA_IMAGE_DEFAULTS, ...raw };
// }

// // ═══════════════════════════════════════════════════════════════════════════
// // UI primitives
// // ═══════════════════════════════════════════════════════════════════════════

// function Section({ label, icon, color = '#c8f04a', children, collapsible = false }) {
//   const [open, setOpen] = useState(true);
//   return (
//     <div style={{
//       background: '#111',
//       border: '1px solid #222',
//       borderRadius: 12,
//       padding: '16px',
//       marginBottom: 16,
//     }}>
//       <div
//         style={{
//           display: 'flex', alignItems: 'center', gap: 10, marginBottom: open ? 16 : 0,
//           cursor: collapsible ? 'pointer' : 'default',
//         }}
//         onClick={collapsible ? () => setOpen(o => !o) : undefined}
//       >
//         <span style={{ fontSize: 16 }}>{icon}</span>
//         <Text style={{
//           fontFamily: 'Space Mono, monospace', fontSize: 11,
//           letterSpacing: '0.22em', textTransform: 'uppercase', color,
//         }}>
//           {label}
//         </Text>
//         {collapsible && (
//           <span style={{ marginLeft: 'auto', color: '#444', fontSize: 12 }}>
//             {open ? '▲' : '▼'}
//           </span>
//         )}
//       </div>
//       {open && children}
//     </div>
//   );
// }

// // ── Field: stacks label above control on mobile ───────────────────────────
// function Field({ label, hint, children, isMobile }) {
//   if (isMobile) {
//     return (
//       <div style={{ marginBottom: 16 }}>
//         <div style={{ marginBottom: 6 }}>
//           <Text style={{ fontSize: 12, color: '#aaa', fontFamily: 'Space Mono, monospace' }}>
//             {label}
//           </Text>
//           {hint && <div><Text style={{ fontSize: 10, color: '#444' }}>{hint}</Text></div>}
//         </div>
//         <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
//           {children}
//         </div>
//       </div>
//     );
//   }
//   return (
//     <div style={{
//       display: 'grid',
//       gridTemplateColumns: '180px 1fr auto',
//       alignItems: 'center',
//       gap: 16, marginBottom: 14, minHeight: 36,
//     }}>
//       <div>
//         <Text style={{ fontSize: 13, color: '#aaa', fontFamily: 'Space Mono, monospace' }}>
//           {label}
//         </Text>
//         {hint && <div><Text style={{ fontSize: 11, color: '#444' }}>{hint}</Text></div>}
//       </div>
//       {children}
//     </div>
//   );
// }

// // ── SliderField: responsive ───────────────────────────────────────────────
// function SliderField({ label, hint, value, onChange, min, max, step = 1, unit = '', isMobile }) {
//   if (isMobile) {
//     return (
//       <div style={{ marginBottom: 16 }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
//           <Text style={{ fontSize: 11, color: '#aaa', fontFamily: 'Space Mono, monospace' }}>{label}</Text>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
//             <InputNumber
//               size="small" min={min} max={max} step={step} value={value}
//               onChange={v => v !== null && onChange(v)}
//               style={{
//                 width: 64, background: '#0a0a0a', border: '1px solid #333',
//                 color: '#c8f04a', fontFamily: 'Space Mono, monospace', fontSize: 11,
//               }}
//             />
//             {unit && <Text style={{ fontSize: 10, color: '#555', fontFamily: 'Space Mono, monospace' }}>{unit}</Text>}
//           </div>
//         </div>
//         {hint && <Text style={{ fontSize: 10, color: '#444', display: 'block', marginBottom: 4 }}>{hint}</Text>}
//         <Slider
//           min={min} max={max} step={step} value={value} onChange={onChange}
//           styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }}
//         />
//       </div>
//     );
//   }
//   return (
//     <Field label={label} hint={hint}>
//       <Slider
//         min={min} max={max} step={step} value={value} onChange={onChange}
//         styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }}
//       />
//       <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 90 }}>
//         <InputNumber
//           size="small" min={min} max={max} step={step} value={value}
//           onChange={v => v !== null && onChange(v)}
//           style={{
//             width: 72, background: '#0a0a0a', border: '1px solid #333',
//             color: '#c8f04a', fontFamily: 'Space Mono, monospace', fontSize: 12,
//           }}
//         />
//         {unit && <Text style={{ fontSize: 11, color: '#555', fontFamily: 'Space Mono, monospace' }}>{unit}</Text>}
//       </div>
//     </Field>
//   );
// }

// function TextInput({ label, hint, value, onChange, multiline = false, placeholder = '', isMobile }) {
//   const base = {
//     width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a',
//     borderRadius: 6, color: '#f0ece4', fontFamily: 'Space Mono, monospace',
//     fontSize: 12, padding: '7px 10px', outline: 'none',
//     boxSizing: 'border-box', resize: multiline ? 'vertical' : 'none',
//   };

//   if (isMobile) {
//     return (
//       <div style={{ marginBottom: 14 }}>
//         <Text style={{ fontSize: 12, color: '#aaa', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 6 }}>{label}</Text>
//         {hint && <Text style={{ fontSize: 10, color: '#444', display: 'block', marginBottom: 4 }}>{hint}</Text>}
//         {multiline ? (
//           <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} rows={3} style={base} />
//         ) : (
//           <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={base} />
//         )}
//       </div>
//     );
//   }

//   return (
//     <Field label={label} hint={hint}>
//       {multiline ? (
//         <textarea
//           value={value} onChange={e => onChange(e.target.value)}
//           placeholder={placeholder} rows={3}
//           style={{ ...base, gridColumn: '1 / -1' }}
//         />
//       ) : (
//         <input
//           value={value} onChange={e => onChange(e.target.value)}
//           placeholder={placeholder} style={base}
//         />
//       )}
//       <div />
//     </Field>
//   );
// }

// function ColorField({ label, hint, value, onChange, isMobile }) {
//   const inner = (
//     <div style={{ display: 'flex', gap: 8, alignItems: 'center', flex: 1 }}>
//       <input
//         type="color"
//         value={value.startsWith('#') ? value : '#c8f04a'}
//         onChange={e => onChange(e.target.value)}
//         style={{ width: 36, height: 32, border: '1px solid #333', borderRadius: 4, background: '#0a0a0a', cursor: 'pointer', flexShrink: 0 }}
//       />
//       <input
//         value={value}
//         onChange={e => onChange(e.target.value)}
//         placeholder="#f0ece4 or var(--acid, #c8f04a)"
//         style={{
//           flex: 1, background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: 6,
//           color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11,
//           padding: '7px 10px', outline: 'none', minWidth: 0,
//         }}
//       />
//     </div>
//   );

//   if (isMobile) {
//     return (
//       <div style={{ marginBottom: 14 }}>
//         <Text style={{ fontSize: 12, color: '#aaa', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 6 }}>{label}</Text>
//         {inner}
//       </div>
//     );
//   }

//   return (
//     <Field label={label} hint={hint}>
//       {inner}
//       <div />
//     </Field>
//   );
// }

// // ── TabBar: scrollable on mobile ──────────────────────────────────────────
// function TabBar({ active, onChange, isMobile }) {
//   const tabs = ['Text', 'Desktop', 'Mobile', 'Img1 Curve', 'Image 2', 'Extras', 'General'];
//   const tabsFull = ['Text', 'Desktop', 'Mobile', 'Image 1 Curve', 'Image 2', 'Extra Images', 'General'];
//   const colors = {
//     'Text': '#ffd666', 'Desktop': '#c8f04a', 'Mobile': '#00e5ff',
//     'Img1 Curve': '#86efac', 'Image 1 Curve': '#86efac',
//     'Image 2': '#a78bfa', 'Extras': '#fb923c', 'Extra Images': '#fb923c',
//     'General': '#ff6b6b',
//   };

//   // Normalize active tab label for matching
//   const activeNorm = active
//     .replace('Image 1 Curve', 'Img1 Curve')
//     .replace('Extra Images', 'Extras');

//   const displayTabs = isMobile ? tabs : tabsFull;

//   const handleClick = (t) => {
//     // Map short labels back to full names for state
//     const full = {
//       'Img1 Curve': 'Image 1 Curve',
//       'Extras': 'Extra Images',
//     };
//     onChange(full[t] || t);
//   };

//   if (isMobile) {
//     return (
//       <div style={{
//         display: 'flex',
//         overflowX: 'auto',
//         gap: 4,
//         marginBottom: 16,
//         background: '#111',
//         padding: 4,
//         borderRadius: 10,
//         border: '1px solid #222',
//         WebkitOverflowScrolling: 'touch',
//         scrollbarWidth: 'none',
//         msOverflowStyle: 'none',
//       }}>
//         {displayTabs.map(t => {
//           const isActive = activeNorm === t || active === t;
//           return (
//             <button key={t} onClick={() => handleClick(t)} style={{
//               flexShrink: 0,
//               padding: '8px 12px',
//               borderRadius: 8, border: 'none',
//               cursor: 'pointer', fontFamily: 'Space Mono, monospace', fontSize: 9,
//               letterSpacing: '0.1em', textTransform: 'uppercase',
//               background: isActive ? colors[t] : 'transparent',
//               color: isActive ? '#000' : '#555',
//               transition: 'all 0.18s ease',
//               fontWeight: isActive ? 700 : 400,
//               whiteSpace: 'nowrap',
//             }}>
//               {t}
//             </button>
//           );
//         })}
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 20,
//       background: '#111', padding: 4, borderRadius: 10, border: '1px solid #222',
//     }}>
//       {displayTabs.map(t => (
//         <button key={t} onClick={() => onChange(t)} style={{
//           flex: '1 1 auto', padding: '8px 10px', borderRadius: 8, border: 'none',
//           cursor: 'pointer', fontFamily: 'Space Mono, monospace', fontSize: 10,
//           letterSpacing: '0.1em', textTransform: 'uppercase',
//           background: active === t ? colors[t] : 'transparent',
//           color: active === t ? '#000' : '#555',
//           transition: 'all 0.18s ease',
//           fontWeight: active === t ? 700 : 400,
//         }}>
//           {t}
//         </button>
//       ))}
//     </div>
//   );
// }

// // ── Motion preview canvas: fluid width ───────────────────────────────────
// function MotionPreview({ cfg, progress = 0.5, extraImages = [] }) {
//   const containerRef = useRef(null);
//   const [W, setW] = useState(320);
//   const H = Math.round(W * (180 / 320));

//   useEffect(() => {
//     if (!containerRef.current) return;
//     const ro = new ResizeObserver(entries => {
//       for (const e of entries) {
//         setW(Math.floor(e.contentRect.width));
//       }
//     });
//     ro.observe(containerRef.current);
//     return () => ro.disconnect();
//   }, []);

//   const vw = v => (v / 100) * W;
//   const vh = v => (v / 100) * H;

//   function smooth(t) { return t * t * (3 - 2 * t); }
//   function computeRot(p, rotStart, pA, pB, rotAtA, rotAtB) {
//     if (p <= pA) {
//       const t = pA === 0 ? 1 : p / pA;
//       return rotStart + (rotAtA - rotStart) * smooth(t);
//     }
//     if (p <= pB) {
//       const t = (pB === pA) ? 1 : (p - pA) / (pB - pA);
//       return rotAtA + (rotAtB - rotAtA) * smooth(t);
//     }
//     return rotAtB;
//   }

//   const x1s = vw(cfg.img1StartX_desktop), y1s = vh(cfg.img1StartY_desktop);
//   const x1e = vw(cfg.img1EndX_desktop),   y1e = vh(cfg.img1EndY_desktop);
//   const cx  = W / 2, cy = H / 2;

//   const x1 = x1s + (x1e - x1s) * progress + cx;
//   const y1 = y1s + (y1e - y1s) * progress + cy;
//   const rot1 = (cfg.img1pA_desktop === 0 && cfg.img1pB_desktop === 0)
//     ? cfg.img1StartRot + (cfg.img1EndRot - cfg.img1StartRot) * progress
//     : computeRot(progress, cfg.img1StartRot, cfg.img1pA_desktop, cfg.img1pB_desktop, cfg.img1RotAtA_desktop, cfg.img1RotAtB_desktop);

//   const trail = cfg.trail || 0.38;
//   const p2 = Math.max(0, progress - trail) / (1 - trail);
//   const x2 = x1s + (x1e - x1s) * p2 + cx;
//   const y2 = y1s + (y1e - y1s) * p2 + cy;
//   const op2 = Math.min(1, p2 / Math.max(cfg.img2FadeStart || 0.1, 0.001));
//   const rot2Start = cfg.img1StartRot + (cfg.rot2InitOffset || -18);
//   const rot2 = computeRot(p2, rot2Start, cfg.pA_desktop || 0.22, cfg.pB_desktop || 0.62, cfg.rot2AtA_desktop || -40, cfg.rot2AtB_desktop || -30);

//   const imgW = Math.max(20, W * 0.11);
//   const imgH = Math.round(imgW * 1.44);

//   const extraBoxes = extraImages.filter(ex => !ex.hidden && ex.url).map((ex, i) => {
//     const exTrail  = ex.trail ?? 0.45;
//     const pEx      = Math.max(0, progress - exTrail) / (1 - exTrail);
//     const opEx     = Math.min(1, pEx / Math.max(ex.img2FadeStart ?? 0.1, 0.001));
//     const exRotStart = cfg.img1StartRot + (ex.rot2InitOffset ?? -18);
//     const exRot    = computeRot(pEx, exRotStart, ex.pA_desktop ?? 0.22, ex.pB_desktop ?? 0.62, ex.rot2AtA_desktop ?? -40, ex.rot2AtB_desktop ?? -30);
//     const exXs = vw(ex.startX_desktop ?? -30), exYs = vh(ex.startY_desktop ?? 90);
//     const exXe = vw(ex.endX_desktop   ??  95), exYe = vh(ex.endY_desktop   ?? -95);
//     const exX  = exXs + (exXe - exXs) * pEx + cx;
//     const exY  = exYs + (exYe - exYs) * pEx + cy;
//     return { exX, exY, exRot, opEx, label: ex.label || `+${i + 1}`, i };
//   });

//   const colors = ['#fb923c', '#f472b6', '#34d399', '#60a5fa', '#facc15'];

//   return (
//     <div ref={containerRef} style={{ background: '#000', border: '1px solid #222', borderRadius: 10, overflow: 'hidden', marginBottom: 16, width: '100%' }}>
//       <div style={{ padding: '6px 12px', borderBottom: '1px solid #1a1a1a', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
//         <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
//           Motion preview
//         </Text>
//         <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
//           {cfg.img1Hidden && <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 8, color: '#444', background: '#1a1a1a', borderRadius: 3, padding: '1px 5px' }}>IMG1 HIDDEN</span>}
//           {cfg.img2Hidden && <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 8, color: '#444', background: '#1a1a1a', borderRadius: 3, padding: '1px 5px' }}>IMG2 HIDDEN</span>}
//           <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#c8f04a' }}>{Math.round(progress * 100)}% scroll</Text>
//         </div>
//       </div>
//       <svg width={W} height={H} style={{ display: 'block' }}>
//         {[...Array(7)].map((_, i) => <line key={`v${i}`} x1={i * W / 6} y1={0} x2={i * W / 6} y2={H} stroke="#111" strokeWidth={0.5} />)}
//         {[...Array(5)].map((_, i) => <line key={`h${i}`} x1={0} y1={i * H / 4} x2={W} y2={i * H / 4} stroke="#111" strokeWidth={0.5} />)}
//         <line x1={x1s + cx} y1={y1s + cy} x2={x1e + cx} y2={y1e + cy} stroke="#1a1a1a" strokeWidth={1} strokeDasharray="4 4" />

//         {extraBoxes.map(({ exX, exY, exRot, opEx, label, i }) => {
//           const color = colors[i % colors.length];
//           const visEx = extraImages.filter(e => !e.hidden && e.url)[i];
//           const exXs2 = vw(visEx?.startX_desktop ?? -30);
//           const exYs2 = vh(visEx?.startY_desktop ?? 90);
//           const exXe2 = vw(visEx?.endX_desktop   ?? 95);
//           const exYe2 = vh(visEx?.endY_desktop   ?? -95);
//           return (
//             <g key={i}>
//               <line x1={exXs2 + cx} y1={exYs2 + cy} x2={exXe2 + cx} y2={exYe2 + cy}
//                 stroke={color} strokeWidth={0.5} strokeDasharray="3 4" strokeOpacity={0.2} />
//               <g transform={`translate(${exX},${exY}) rotate(${exRot})`} opacity={opEx}>
//                 <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
//                   fill={color} fillOpacity={0.15} stroke={color} strokeWidth={1} strokeOpacity={0.5} />
//                 <text x={0} y={4} textAnchor="middle" fill={color} fontSize={Math.max(6, imgW * 0.18)} fontFamily="Space Mono, monospace">{label}</text>
//               </g>
//             </g>
//           );
//         })}

//         {!cfg.img2Hidden && (
//           <g transform={`translate(${x2},${y2}) rotate(${rot2})`} opacity={op2}>
//             <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
//               fill="#a78bfa" fillOpacity={0.25} stroke="#a78bfa" strokeWidth={1} strokeOpacity={0.5} />
//             <text x={0} y={4} textAnchor="middle" fill="#a78bfa" fontSize={Math.max(6, imgW * 0.18)} fontFamily="Space Mono, monospace">IMG 2</text>
//           </g>
//         )}
//         {cfg.img2Hidden && (
//           <g transform={`translate(${x2},${y2}) rotate(${rot2})`} opacity={0.15}>
//             <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
//               fill="transparent" stroke="#333" strokeWidth={1} strokeDasharray="3 3" />
//             <text x={0} y={4} textAnchor="middle" fill="#333" fontSize={Math.max(5, imgW * 0.15)} fontFamily="Space Mono, monospace">HIDDEN</text>
//           </g>
//         )}

//         {!cfg.img1Hidden && (
//           <g transform={`translate(${x1},${y1}) rotate(${rot1})`}>
//             <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
//               fill="#c8f04a" fillOpacity={0.2} stroke="#c8f04a" strokeWidth={1.5} />
//             <text x={0} y={4} textAnchor="middle" fill="#c8f04a" fontSize={Math.max(6, imgW * 0.18)} fontFamily="Space Mono, monospace">IMG 1</text>
//           </g>
//         )}
//         {cfg.img1Hidden && (
//           <g transform={`translate(${x1},${y1}) rotate(${rot1})`} opacity={0.15}>
//             <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
//               fill="transparent" stroke="#444" strokeWidth={1} strokeDasharray="3 3" />
//             <text x={0} y={4} textAnchor="middle" fill="#444" fontSize={Math.max(5, imgW * 0.15)} fontFamily="Space Mono, monospace">HIDDEN</text>
//           </g>
//         )}

//         <line x1={cx - 6} y1={cy} x2={cx + 6} y2={cy} stroke="#333" strokeWidth={0.5} />
//         <line x1={cx} y1={cy - 6} x2={cx} y2={cy + 6} stroke="#333" strokeWidth={0.5} />
//       </svg>
//     </div>
//   );
// }

// // ── Compact slider for use inside ExtraImageEditor ────────────────────────
// function MiniSlider({ label, value, onChange, min, max, step, unit = '' }) {
//   return (
//     <div style={{ marginBottom: 10 }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
//         <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#666' }}>{label}</Text>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//           <InputNumber size="small" min={min} max={max} step={step} value={value}
//             onChange={v => v !== null && onChange(v)}
//             style={{ width: 52, background: '#0a0a0a', border: '1px solid #2a2a2a', color: '#c8f04a', fontFamily: 'Space Mono, monospace', fontSize: 10 }}
//           />
//           {unit && <Text style={{ fontSize: 9, color: '#444', fontFamily: 'Space Mono, monospace' }}>{unit}</Text>}
//         </div>
//       </div>
//       <Slider min={min} max={max} step={step} value={value} onChange={onChange}
//         styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }} />
//     </div>
//   );
// }

// // ── Per-extra-image config editor ─────────────────────────────────────────
// function ExtraImageEditor({ ex, idx, total, onChange, onRemove, onMove }) {
//   const [open, setOpen] = useState(false);
//   const [posTab, setPosTab] = useState('desktop');
//   const screens = useBreakpoint();
//   const isMobile = !screens.md;
//   const colors = ['#fb923c', '#f472b6', '#34d399', '#60a5fa', '#facc15'];
//   const color = colors[idx % colors.length];

//   const set = (key, val) => onChange({ ...ex, [key]: val });

//   const posBtnStyle = (active) => ({
//     padding: '3px 10px', borderRadius: 4, border: 'none', cursor: 'pointer',
//     fontFamily: 'Space Mono, monospace', fontSize: 9,
//     letterSpacing: '0.1em', textTransform: 'uppercase',
//     background: active ? color + '22' : 'transparent',
//     color: active ? color : '#444',
//     transition: 'all 0.15s',
//   });

//   const presetBtnStyle = {
//     padding: '3px 8px', borderRadius: 4, border: '1px solid #1e1e1e',
//     background: '#111', color: '#555', fontFamily: 'Space Mono, monospace',
//     fontSize: 9, cursor: 'pointer', letterSpacing: '0.05em', transition: 'all 0.12s',
//   };

//   return (
//     <div style={{
//       background: '#0a0a0a',
//       border: `1px solid ${ex.hidden ? '#1a1a1a' : color + '44'}`,
//       borderRadius: 10,
//       marginBottom: 10,
//       overflow: 'hidden',
//       opacity: ex.hidden ? 0.5 : 1,
//       transition: 'opacity 0.2s',
//     }}>
//       {/* Header row */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: isMobile ? '52px 1fr auto' : '64px 1fr auto',
//         alignItems: 'center',
//         gap: 10,
//         padding: '10px 12px',
//       }}>
//         {/* Thumbnail */}
//         <div style={{
//           width: isMobile ? 52 : 64,
//           height: isMobile ? 66 : 80,
//           borderRadius: 6,
//           background: '#181818', border: '1px solid #252525',
//           overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
//         }}>
//           {ex.url ? (
//             <img src={ex.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//               onError={e => { e.currentTarget.style.display = 'none'; }} />
//           ) : (
//             <span style={{ color: '#2a2a2a', fontSize: 16 }}>?</span>
//           )}
//         </div>

//         {/* Labels + inputs */}
//         <div style={{ minWidth: 0 }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 5, flexWrap: 'wrap' }}>
//             <span style={{
//               fontFamily: 'Space Mono, monospace', fontSize: 9, color,
//               background: color + '18', border: `1px solid ${color}33`,
//               borderRadius: 3, padding: '1px 5px', whiteSpace: 'nowrap',
//             }}>#{String(idx + 1).padStart(2, '0')}</span>
//             {ex.hidden && (
//               <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 8, color: '#555', background: '#1a1a1a', borderRadius: 3, padding: '1px 5px' }}>HIDDEN</span>
//             )}
//           </div>
//           <input
//             value={ex.label || ''}
//             onChange={e => set('label', e.target.value)}
//             placeholder="Label (optional)"
//             style={{
//               width: '100%', background: '#111', border: '1px solid #1e1e1e', borderRadius: 5,
//               color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11,
//               padding: '4px 7px', outline: 'none', boxSizing: 'border-box', marginBottom: 4,
//             }}
//           />
//           <input
//             value={ex.url || ''}
//             onChange={e => set('url', e.target.value)}
//             placeholder="https://... or ./image.png"
//             style={{
//               width: '100%', background: '#111', border: '1px solid #1e1e1e', borderRadius: 5,
//               color: '#888', fontFamily: 'Space Mono, monospace', fontSize: 10,
//               padding: '4px 7px', outline: 'none', boxSizing: 'border-box',
//             }}
//           />
//         </div>

//         {/* Action buttons */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
//           {[
//             { title: ex.hidden ? 'Show' : 'Hide', icon: ex.hidden ? '👁' : '✓', bg: ex.hidden ? '#1a1a1a' : '#0d2010', fg: ex.hidden ? '#444' : '#4ade80', onClick: () => set('hidden', !ex.hidden), border: 'none' },
//             { title: 'Settings', icon: '⚙', bg: open ? color + '18' : '#111', fg: open ? color : '#444', onClick: () => setOpen(o => !o), border: `1px solid ${open ? color + '66' : '#222'}` },
//             { title: 'Move up', icon: '↑', bg: '#111', fg: idx === 0 ? '#2a2a2a' : '#888', onClick: () => onMove(idx, -1), border: '1px solid #222', disabled: idx === 0 },
//             { title: 'Move down', icon: '↓', bg: '#111', fg: idx === total - 1 ? '#2a2a2a' : '#888', onClick: () => onMove(idx, 1), border: '1px solid #222', disabled: idx === total - 1 },
//             { title: 'Remove', icon: '×', bg: '#1a0808', fg: '#ff6b6b', onClick: onRemove, border: '1px solid #3a1515' },
//           ].map((btn, bi) => (
//             <button key={bi} title={btn.title} onClick={btn.onClick} disabled={btn.disabled}
//               style={{
//                 width: 28, height: 28, borderRadius: 6, border: btn.border, cursor: btn.disabled ? 'default' : 'pointer',
//                 background: btn.bg, color: btn.fg, fontSize: 13,
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//               }}>
//               {btn.icon}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Expanded config */}
//       {open && (
//         <div style={{ borderTop: '1px solid #1a1a1a', padding: '14px 14px', background: '#080808' }}>
//           {/* Position section */}
//           <div style={{ marginBottom: 16 }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 6 }}>
//               <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase' }}>
//                 Position
//               </Text>
//               <div style={{ display: 'flex', gap: 2, background: '#111', borderRadius: 5, padding: 2, border: '1px solid #1e1e1e' }}>
//                 <button style={posBtnStyle(posTab === 'desktop')} onClick={() => setPosTab('desktop')}>Desktop</button>
//                 <button style={posBtnStyle(posTab === 'mobile')}  onClick={() => setPosTab('mobile')}>Mobile</button>
//               </div>
//             </div>

//             {posTab === 'desktop' && (
//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
//                 <div>
//                   <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>Start</div>
//                   <MiniSlider label="Start X" value={ex.startX_desktop ?? -30} onChange={v => set('startX_desktop', v)} min={-150} max={150} step={1} unit="vw" />
//                   <MiniSlider label="Start Y" value={ex.startY_desktop ??  90} onChange={v => set('startY_desktop', v)} min={-150} max={200} step={1} unit="vh" />
//                 </div>
//                 <div>
//                   <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>End</div>
//                   <MiniSlider label="End X" value={ex.endX_desktop ??  95} onChange={v => set('endX_desktop', v)} min={-150} max={200} step={1} unit="vw" />
//                   <MiniSlider label="End Y" value={ex.endY_desktop ?? -95} onChange={v => set('endY_desktop', v)} min={-200} max={200} step={1} unit="vh" />
//                 </div>
//               </div>
//             )}

//             {posTab === 'mobile' && (
//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
//                 <div>
//                   <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>Start</div>
//                   <MiniSlider label="Start X" value={ex.startX_mobile ?? -60} onChange={v => set('startX_mobile', v)} min={-150} max={150} step={1} unit="vw" />
//                   <MiniSlider label="Start Y" value={ex.startY_mobile ??  80} onChange={v => set('startY_mobile', v)} min={-150} max={200} step={1} unit="vh" />
//                 </div>
//                 <div>
//                   <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>End</div>
//                   <MiniSlider label="End X" value={ex.endX_mobile   ?? 100} onChange={v => set('endX_mobile', v)} min={-150} max={200} step={1} unit="vw" />
//                   <MiniSlider label="End Y" value={ex.endY_mobile   ?? -90} onChange={v => set('endY_mobile', v)} min={-200} max={200} step={1} unit="vh" />
//                 </div>
//               </div>
//             )}

//             {/* Presets */}
//             {['start', 'end'].map(type => (
//               <div key={type} style={{ marginTop: 10 }}>
//                 <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#444', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 6 }}>
//                   Quick {type} presets ({posTab})
//                 </Text>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
//                   {(type === 'start' ? [
//                     { label: '↙ BL',  sx: -30, sy:  90 },
//                     { label: '↓ BM',  sx:   0, sy:  90 },
//                     { label: '↘ BR',  sx:  80, sy:  90 },
//                     { label: '← ML',  sx: -60, sy:   0 },
//                     { label: '✦ C',   sx:   0, sy:   0 },
//                     { label: '→ MR',  sx:  80, sy:   0 },
//                     { label: '↖ TL',  sx: -30, sy: -90 },
//                     { label: '↑ TM',  sx:   0, sy: -90 },
//                     { label: '↗ TR',  sx:  80, sy: -90 },
//                   ] : [
//                     { label: '↙ BL',  ex_: -30, ey:  90 },
//                     { label: '↓ BM',  ex_:   0, ey:  90 },
//                     { label: '↘ BR',  ex_:  80, ey:  90 },
//                     { label: '← ML',  ex_: -60, ey:   0 },
//                     { label: '✦ C',   ex_:   0, ey:   0 },
//                     { label: '→ MR',  ex_:  80, ey:   0 },
//                     { label: '↖ TL',  ex_: -30, ey: -90 },
//                     { label: '↑ TM',  ex_:  50, ey: -95 },
//                     { label: '↗ TR',  ex_:  95, ey: -95 },
//                   ]).map(preset => (
//                     <button key={preset.label}
//                       onClick={() => {
//                         if (type === 'start') {
//                           if (posTab === 'desktop') onChange({ ...ex, startX_desktop: preset.sx, startY_desktop: preset.sy });
//                           else onChange({ ...ex, startX_mobile: preset.sx, startY_mobile: preset.sy });
//                         } else {
//                           if (posTab === 'desktop') onChange({ ...ex, endX_desktop: preset.ex_, endY_desktop: preset.ey });
//                           else onChange({ ...ex, endX_mobile: preset.ex_, endY_mobile: preset.ey });
//                         }
//                       }}
//                       style={presetBtnStyle}
//                       onMouseEnter={e => { e.currentTarget.style.color = color; e.currentTarget.style.borderColor = color + '55'; }}
//                       onMouseLeave={e => { e.currentTarget.style.color = '#555'; e.currentTarget.style.borderColor = '#1e1e1e'; }}
//                     >{preset.label}</button>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>

//           <Divider style={{ borderColor: '#1a1a1a', margin: '4px 0 14px' }} />

//           <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
//             <div>
//               <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Trail &amp; Fade</Text>
//               <MiniSlider label="Trail" value={ex.trail ?? 0.45} onChange={v => set('trail', v)} min={0} max={0.95} step={0.01} />
//               <MiniSlider label="Fade window" value={ex.img2FadeStart ?? 0.1} onChange={v => set('img2FadeStart', v)} min={0.01} max={0.5} step={0.01} />
//               <MiniSlider label="Init rot offset" value={ex.rot2InitOffset ?? -18} onChange={v => set('rot2InitOffset', v)} min={-90} max={90} step={1} unit="°" />
//               <Divider style={{ borderColor: '#1a1a1a', margin: '8px 0' }} />
//               <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Sizes</Text>
//               <MiniSlider label="Width desktop" value={ex.widthVw_desktop ?? 20} onChange={v => set('widthVw_desktop', v)} min={5} max={60} step={1} unit="vw" />
//               <MiniSlider label="Width mobile" value={ex.widthVw_mobile ?? 44} onChange={v => set('widthVw_mobile', v)} min={5} max={80} step={1} unit="vw" />
//               <MiniSlider label="Z-index" value={ex.zIndex ?? 8} onChange={v => set('zIndex', v)} min={1} max={20} step={1} />
//             </div>
//             <div>
//               <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Rot curve — desktop</Text>
//               <MiniSlider label="Point A" value={ex.pA_desktop ?? 0.22} onChange={v => set('pA_desktop', v)} min={0} max={1} step={0.01} />
//               <MiniSlider label="Point B" value={ex.pB_desktop ?? 0.62} onChange={v => set('pB_desktop', v)} min={0} max={1} step={0.01} />
//               <MiniSlider label="Rot at A" value={ex.rot2AtA_desktop ?? -40} onChange={v => set('rot2AtA_desktop', v)} min={-180} max={180} step={1} unit="°" />
//               <MiniSlider label="Rot at B" value={ex.rot2AtB_desktop ?? -30} onChange={v => set('rot2AtB_desktop', v)} min={-180} max={180} step={1} unit="°" />
//               <Divider style={{ borderColor: '#1a1a1a', margin: '8px 0' }} />
//               <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Rot curve — mobile</Text>
//               <MiniSlider label="Point A" value={ex.pA_mobile ?? 0.48} onChange={v => set('pA_mobile', v)} min={0} max={1} step={0.01} />
//               <MiniSlider label="Point B" value={ex.pB_mobile ?? 0.52} onChange={v => set('pB_mobile', v)} min={0} max={1} step={0.01} />
//               <MiniSlider label="Rot at A" value={ex.rot2AtA_mobile ?? -60} onChange={v => set('rot2AtA_mobile', v)} min={-180} max={180} step={1} unit="°" />
//               <MiniSlider label="Rot at B" value={ex.rot2AtB_mobile ?? -60} onChange={v => set('rot2AtB_mobile', v)} min={-180} max={180} step={1} unit="°" />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // ── Add new extra image ───────────────────────────────────────────────────
// function AddExtraImageRow({ onAdd }) {
//   const [val, setVal] = useState('');
//   const [label, setLabel] = useState('');
//   const [preview, setPreview] = useState(false);

//   const commit = () => {
//     const trimmed = val.trim();
//     if (!trimmed) return;
//     onAdd({ ...EXTRA_IMAGE_DEFAULTS, url: trimmed, label: label.trim() || 'Extra image' });
//     setVal(''); setLabel(''); setPreview(false);
//   };

//   const inputStyle = {
//     background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: 5,
//     color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11,
//     padding: '5px 8px', outline: 'none', width: '100%', boxSizing: 'border-box',
//   };

//   return (
//     <div style={{ padding: 14, background: '#0d0d0d', borderRadius: 10, border: '1px dashed #2a2a2a', marginTop: 6 }}>
//       <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#ffd666', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>
//         Add new extra image
//       </Text>
//       <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
//         <div style={{ width: 64, height: 80, flexShrink: 0, borderRadius: 7, background: '#111', border: '1px dashed #252525', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           {preview && val.trim()
//             ? <img src={val.trim()} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.currentTarget.style.display = 'none'; }} />
//             : <span style={{ color: '#2a2a2a', fontSize: 22 }}>+</span>}
//         </div>
//         <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 7, minWidth: 0 }}>
//           <input value={label} onChange={e => setLabel(e.target.value)} placeholder="Label" style={inputStyle} />
//           <input value={val} onChange={e => { setVal(e.target.value); setPreview(false); }}
//             onKeyDown={e => { if (e.key === 'Enter') commit(); }}
//             placeholder="URL or ./path.png" style={inputStyle} />
//           <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
//             <button onClick={() => setPreview(true)} disabled={!val.trim()}
//               style={{ fontSize: 10, fontFamily: 'Space Mono, monospace', color: val.trim() ? '#ffd666' : '#2a2a2a', background: 'transparent', border: 'none', cursor: val.trim() ? 'pointer' : 'default', textDecoration: val.trim() ? 'underline dotted' : 'none', padding: 0 }}>
//               Preview
//             </button>
//             <button onClick={commit} disabled={!val.trim()}
//               style={{ padding: '4px 14px', borderRadius: 6, border: val.trim() ? '1px solid #ffd66666' : '1px solid #222', background: val.trim() ? '#ffd66618' : '#111', color: val.trim() ? '#ffd666' : '#333', fontFamily: 'Space Mono, monospace', fontSize: 11, cursor: val.trim() ? 'pointer' : 'default', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
//               Add ↵
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Core image visibility toggle ──────────────────────────────────────────
// function VisibilityToggle({ hidden, onToggle, label, color }) {
//   return (
//     <button
//       onClick={onToggle}
//       title={hidden ? `Show ${label}` : `Hide ${label}`}
//       style={{
//         display: 'flex', alignItems: 'center', gap: 6,
//         padding: '5px 12px', borderRadius: 8,
//         border: `1px solid ${hidden ? '#2a2a2a' : color + '55'}`,
//         background: hidden ? '#111' : color + '14',
//         cursor: 'pointer', transition: 'all 0.18s ease',
//         fontFamily: 'Space Mono, monospace', fontSize: 11,
//         letterSpacing: '0.08em', color: hidden ? '#444' : color,
//         whiteSpace: 'nowrap',
//       }}
//     >
//       <span style={{ fontSize: 13, lineHeight: 1 }}>{hidden ? '🚫' : '✓'}</span>
//       <span>{hidden ? 'Hidden' : 'Visible'}</span>
//     </button>
//   );
// }

// // ═══════════════════════════════════════════════════════════════════════════
// // Main page
// // ═══════════════════════════════════════════════════════════════════════════
// export default function ImageControlPage() {
//   const [cfg, setCfg] = useState({ ...DEFAULTS });
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [dirty, setDirty] = useState(false);
//   const [tab, setTab] = useState('Text');
//   const [previewProgress, setPreviewProgress] = useState(50);
//   const screens = useBreakpoint();
//   const isMobile = !screens.md;

//   useEffect(() => {
//     (async () => {
//       try {
//         const remote = await loadConfig();
//         if (remote) {
//           setCfg(prev => ({
//             ...prev, ...remote,
//             extraImages: safeArray(remote.extraImages).map(mergeExtra),
//           }));
//         }
//       } catch { message.warning('Could not load config — using defaults'); }
//       finally { setLoading(false); }
//     })();
//   }, []);

//   const set = useCallback((key, val) => {
//     setCfg(prev => ({ ...prev, [key]: val }));
//     setDirty(true);
//   }, []);

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       await saveConfig(cfg);
//       message.success('Config saved to Firestore ✓');
//       setDirty(false);
//     } catch (e) { message.error(`Save failed: ${e.message}`); }
//     finally { setSaving(false); }
//   };

//   const handleReset = () => {
//     setCfg({ ...DEFAULTS });
//     setDirty(true);
//     message.info('Reset to defaults — press Save to persist');
//   };

//   const extraImages = safeArray(cfg.extraImages).map(mergeExtra);

//   const updateExtra = (idx, updated) => {
//     const next = [...extraImages];
//     next[idx] = updated;
//     set('extraImages', next);
//   };
//   const removeExtra = (idx) => {
//     const next = [...extraImages];
//     next.splice(idx, 1);
//     set('extraImages', next);
//   };
//   const moveExtra = (idx, dir) => {
//     const next = [...extraImages];
//     const target = idx + dir;
//     if (target < 0 || target >= next.length) return;
//     [next[idx], next[target]] = [next[target], next[idx]];
//     set('extraImages', next);
//   };

//   if (loading) return (
//     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300 }}>
//       <Spin size="large" />
//     </div>
//   );

//   // Pass isMobile down to all field helpers
//   const sf = (props) => <SliderField {...props} isMobile={isMobile} />;

//   const rotCurveNote = (
//     <div style={{ marginBottom: 12, padding: '10px 14px', background: '#0a0a0a', borderRadius: 8, border: '1px solid #1a1a1a' }}>
//       <Text style={{ fontSize: 11, color: '#444', fontFamily: 'Space Mono, monospace', lineHeight: 1.8, display: 'block' }}>
//         Rotation curve: 3 segments — <span style={{ color: '#86efac' }}>rotStart → rotAtA</span> (0 to pA), <span style={{ color: '#86efac' }}>rotAtA → rotAtB</span> (pA to pB), then held.<br />
//         <span style={{ color: '#333' }}>Set pA = pB = 0 to disable and use simple linear lerp.</span>
//       </Text>
//     </div>
//   );

//   return (
//     <div style={{
//       maxWidth: 820,
//       margin: '0 auto',
//       padding: isMobile ? '12px 10px 80px' : '0 0 48px',
//     }}>

//       {/* ── Header ── */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: isMobile ? 'flex-start' : 'center',
//         marginBottom: 20,
//         flexWrap: 'wrap',
//         gap: 10,
//       }}>
//         <div>
//           <Title level={isMobile ? 5 : 4} style={{ margin: 0, color: '#f0ece4' }}>
//             Image + Text Controller
//           </Title>
//           <Text style={{ color: '#555', fontSize: 11, fontFamily: 'Space Mono, monospace' }}>
//             Tools section — animation &amp; content config
//           </Text>
//         </div>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
//           {dirty && !isMobile && <Tag color="warning" style={{ fontFamily: 'Space Mono, monospace', fontSize: 11 }}>Unsaved</Tag>}
//           <Button size={isMobile ? 'small' : 'middle'} icon={<ReloadOutlined />} onClick={handleReset}
//             style={{ background: '#111', border: '1px solid #333', color: '#aaa' }}>
//             {isMobile ? '' : 'Reset'}
//           </Button>
//           <Button type="primary" size={isMobile ? 'small' : 'middle'} icon={<SaveOutlined />}
//             onClick={handleSave} loading={saving} disabled={!dirty}
//             style={{ background: dirty ? '#c8f04a' : '#1a1a1a', border: 'none', color: dirty ? '#000' : '#444', fontWeight: 700 }}>
//             {isMobile ? 'Save' : 'Save to Firestore'}
//           </Button>
//         </div>
//       </div>

//       {/* ── Motion preview ── */}
//       <MotionPreview cfg={cfg} progress={previewProgress / 100} extraImages={extraImages} />
//       <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10 }}>
//         <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#555', whiteSpace: 'nowrap', flexShrink: 0 }}>
//           {isMobile ? 'Scroll' : 'Preview scroll'}
//         </Text>
//         <Slider min={0} max={100} value={previewProgress} onChange={setPreviewProgress} style={{ flex: 1 }}
//           styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }} />
//         <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#c8f04a', minWidth: 30, textAlign: 'right' }}>
//           {previewProgress}%
//         </Text>
//       </div>

//       {/* ── Tabs ── */}
//       <TabBar active={tab} onChange={setTab} isMobile={isMobile} />

//       {/* ══ TEXT TAB ══ */}
//       {tab === 'Text' && (
//         <>
//           <Section label="Overline" icon="✦" color="#ffd666">
//             <TextInput isMobile={isMobile} label="Overline text" hint="Small label above heading"
//               value={cfg.textOverline ?? DEFAULTS.textOverline} onChange={v => set('textOverline', v)} placeholder="Philosophy" />
//           </Section>
//           <Section label="Heading lines" icon="H" color="#ffd666">
//             <TextInput isMobile={isMobile} label="Line 1" value={cfg.textLine1 ?? DEFAULTS.textLine1} onChange={v => set('textLine1', v)} placeholder="Craft over" />
//             <ColorField isMobile={isMobile} label="Line 1 color" value={cfg.textLine1Color ?? DEFAULTS.textLine1Color} onChange={v => set('textLine1Color', v)} />
//             <Divider style={{ borderColor: '#1e1e1e', margin: '6px 0' }} />
//             <TextInput isMobile={isMobile} label="Line 2" value={cfg.textLine2 ?? DEFAULTS.textLine2} onChange={v => set('textLine2', v)} placeholder="shortcuts." />
//             <ColorField isMobile={isMobile} label="Line 2 color" value={cfg.textLine2Color ?? DEFAULTS.textLine2Color} onChange={v => set('textLine2Color', v)} />
//             <Divider style={{ borderColor: '#1e1e1e', margin: '6px 0' }} />
//             <TextInput isMobile={isMobile} label="Line 3" value={cfg.textLine3 ?? DEFAULTS.textLine3} onChange={v => set('textLine3', v)} placeholder="Always." />
//             <ColorField isMobile={isMobile} label="Line 3 color" value={cfg.textLine3Color ?? DEFAULTS.textLine3Color} onChange={v => set('textLine3Color', v)} />
//           </Section>
//           <Section label="Sub paragraph" icon="¶" color="#ffd666">
//             <div style={{ marginBottom: 10 }}>
//               {isMobile && <Text style={{ fontSize: 11, color: '#aaa', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 6 }}>Body text</Text>}
//               <textarea
//                 value={cfg.textSub ?? DEFAULTS.textSub}
//                 onChange={e => set('textSub', e.target.value)}
//                 rows={4}
//                 style={{
//                   background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: 6,
//                   color: '#f0ece4', fontFamily: 'Syne, sans-serif', fontSize: 13, lineHeight: 1.7,
//                   padding: '8px 10px', outline: 'none', resize: 'vertical',
//                   width: '100%', boxSizing: 'border-box',
//                 }}
//               />
//             </div>
//           </Section>
//           {/* Live text preview */}
//           <div style={{ background: '#000', border: '1px solid #1a1a1a', borderRadius: 12, padding: isMobile ? '16px' : '24px', textAlign: 'center' }}>
//             <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.72rem', color: '#c8f04a', letterSpacing: '0.28em', textTransform: 'uppercase', marginBottom: '0.8rem' }}>{cfg.textOverline}</div>
//             {[
//               [cfg.textLine1, cfg.textLine1Color],
//               [cfg.textLine2, cfg.textLine2Color],
//               [cfg.textLine3, cfg.textLine3Color],
//             ].map(([line, col], i) => (
//               <div key={i} style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: isMobile ? 'clamp(1.4rem, 8vw, 2rem)' : 'clamp(1.8rem, 5vw, 3rem)', lineHeight: 1, letterSpacing: '-0.04em', color: col, marginBottom: i < 2 ? '0.08em' : '1rem' }}>
//                 {line}
//               </div>
//             ))}
//             <p style={{ fontFamily: 'Syne, sans-serif', fontSize: isMobile ? '0.82rem' : '0.9rem', color: '#666', lineHeight: 1.85, maxWidth: '52ch', margin: '0 auto' }}>{cfg.textSub}</p>
//           </div>
//         </>
//       )}

//       {/* ══ DESKTOP TAB ══ */}
//       {tab === 'Desktop' && (
//         <>
//           <Section label="Image 1 — Start (desktop)" icon="↙" color="#c8f04a">
//             <SliderField isMobile={isMobile} label="Start X" hint="vw from left" value={cfg.img1StartX_desktop} onChange={v => set('img1StartX_desktop', v)} min={-100} max={100} unit="vw" />
//             <SliderField isMobile={isMobile} label="Start Y" hint="vh from top"  value={cfg.img1StartY_desktop} onChange={v => set('img1StartY_desktop', v)} min={-100} max={150} unit="vh" />
//             <SliderField isMobile={isMobile} label="Start rotation" value={cfg.img1StartRot} onChange={v => set('img1StartRot', v)} min={-90} max={90} unit="°" />
//           </Section>
//           <Section label="Image 1 — End (desktop)" icon="↗" color="#c8f04a">
//             <SliderField isMobile={isMobile} label="End X" value={cfg.img1EndX_desktop} onChange={v => set('img1EndX_desktop', v)} min={-100} max={200} unit="vw" />
//             <SliderField isMobile={isMobile} label="End Y" value={cfg.img1EndY_desktop} onChange={v => set('img1EndY_desktop', v)} min={-200} max={100} unit="vh" />
//             <SliderField isMobile={isMobile} label="End rotation" value={cfg.img1EndRot} onChange={v => set('img1EndRot', v)} min={-90} max={90} unit="°" />
//           </Section>
//           <Section label="Image sizes (desktop)" icon="⊡" color="#c8f04a">
//             <SliderField isMobile={isMobile} label="Image 1 width" value={cfg.img1Width_desktop} onChange={v => set('img1Width_desktop', v)} min={5} max={60} unit="vw" />
//             <SliderField isMobile={isMobile} label="Image 2 width" value={cfg.img2Width_desktop} onChange={v => set('img2Width_desktop', v)} min={5} max={60} unit="vw" />
//           </Section>
//         </>
//       )}

//       {/* ══ MOBILE TAB ══ */}
//       {tab === 'Mobile' && (
//         <>
//           <Section label="Image 1 — Start (mobile)" icon="↙" color="#00e5ff">
//             <SliderField isMobile={isMobile} label="Start X" value={cfg.img1StartX_mobile} onChange={v => set('img1StartX_mobile', v)} min={-100} max={100} unit="vw" />
//             <SliderField isMobile={isMobile} label="Start Y" value={cfg.img1StartY_mobile} onChange={v => set('img1StartY_mobile', v)} min={-100} max={150} unit="vh" />
//           </Section>
//           <Section label="Image 1 — End (mobile)" icon="↗" color="#00e5ff">
//             <SliderField isMobile={isMobile} label="End X" value={cfg.img1EndX_mobile} onChange={v => set('img1EndX_mobile', v)} min={-100} max={200} unit="vw" />
//             <SliderField isMobile={isMobile} label="End Y" value={cfg.img1EndY_mobile} onChange={v => set('img1EndY_mobile', v)} min={-200} max={100} unit="vh" />
//           </Section>
//           <Section label="Image sizes (mobile)" icon="⊡" color="#00e5ff">
//             <SliderField isMobile={isMobile} label="Image 1 width" value={cfg.img1Width_mobile} onChange={v => set('img1Width_mobile', v)} min={5} max={80} unit="vw" />
//             <SliderField isMobile={isMobile} label="Image 2 width" value={cfg.img2Width_mobile} onChange={v => set('img2Width_mobile', v)} min={5} max={80} unit="vw" />
//           </Section>
//         </>
//       )}

//       {/* ══ IMAGE 1 CURVE TAB ══ */}
//       {tab === 'Image 1 Curve' && (
//         <>
//           {rotCurveNote}
//           <Section label="Rotation curve — desktop" icon="⤾" color="#86efac">
//             <SliderField isMobile={isMobile} label="Point A (pA)" hint="Segment 1 end" value={cfg.img1pA_desktop} onChange={v => set('img1pA_desktop', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Point B (pB)" hint="Segment 2 end" value={cfg.img1pB_desktop} onChange={v => set('img1pB_desktop', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.img1RotAtA_desktop} onChange={v => set('img1RotAtA_desktop', v)} min={-180} max={180} unit="°" />
//             <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.img1RotAtB_desktop} onChange={v => set('img1RotAtB_desktop', v)} min={-180} max={180} unit="°" />
//           </Section>
//           <Section label="Rotation curve — mobile" icon="⤾" color="#86efac">
//             <SliderField isMobile={isMobile} label="Point A (pA)" value={cfg.img1pA_mobile} onChange={v => set('img1pA_mobile', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Point B (pB)" value={cfg.img1pB_mobile} onChange={v => set('img1pB_mobile', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.img1RotAtA_mobile} onChange={v => set('img1RotAtA_mobile', v)} min={-180} max={180} unit="°" />
//             <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.img1RotAtB_mobile} onChange={v => set('img1RotAtB_mobile', v)} min={-180} max={180} unit="°" />
//           </Section>
//         </>
//       )}

//       {/* ══ IMAGE 2 TAB ══ */}
//       {tab === 'Image 2' && (
//         <>
//           <Section label="Trail & follow delay" icon="👣" color="#a78bfa">
//             <SliderField isMobile={isMobile} label="Trail distance" hint="0 = sync with img1" value={cfg.trail} onChange={v => set('trail', v)} min={0} max={0.95} step={0.01} />
//             <SliderField isMobile={isMobile} label="Fade-in window" hint="Fraction of img2 progress to fade" value={cfg.img2FadeStart} onChange={v => set('img2FadeStart', v)} min={0.01} max={0.5} step={0.01} />
//             <SliderField isMobile={isMobile} label="Init rotation offset" hint="Extra offset on img2 at start" value={cfg.rot2InitOffset} onChange={v => set('rot2InitOffset', v)} min={-90} max={90} unit="°" />
//           </Section>
//           {rotCurveNote}
//           <Section label="Rotation curve — desktop" icon="⤾" color="#a78bfa">
//             <SliderField isMobile={isMobile} label="Point A (pA)" value={cfg.pA_desktop} onChange={v => set('pA_desktop', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Point B (pB)" value={cfg.pB_desktop} onChange={v => set('pB_desktop', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.rot2AtA_desktop} onChange={v => set('rot2AtA_desktop', v)} min={-180} max={180} unit="°" />
//             <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.rot2AtB_desktop} onChange={v => set('rot2AtB_desktop', v)} min={-180} max={180} unit="°" />
//           </Section>
//           <Section label="Rotation curve — mobile" icon="⤾" color="#a78bfa">
//             <SliderField isMobile={isMobile} label="Point A (pA)" value={cfg.pA_mobile} onChange={v => set('pA_mobile', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Point B (pB)" value={cfg.pB_mobile} onChange={v => set('pB_mobile', v)} min={0} max={1} step={0.01} />
//             <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.rot2AtA_mobile} onChange={v => set('rot2AtA_mobile', v)} min={-180} max={180} unit="°" />
//             <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.rot2AtB_mobile} onChange={v => set('rot2AtB_mobile', v)} min={-180} max={180} unit="°" />
//           </Section>
//         </>
//       )}

//       {/* ══ EXTRA IMAGES TAB ══ */}
//       {tab === 'Extra Images' && (
//         <>
//           <div style={{ marginBottom: 12, padding: '10px 14px', background: '#111', borderRadius: 8, border: '1px solid #1e1e1e' }}>
//             <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#555', lineHeight: 1.8, display: 'block' }}>
//               Each extra image has independent position, trail, fade, rotation curve, size, z-index &amp; visibility.<br />
//               Open ⚙ to configure. <span style={{ color: '#c8f04a' }}>✓</span> = visible. <span style={{ color: '#444' }}>👁</span> = hidden.
//             </Text>
//           </div>
//           {extraImages.length === 0 && (
//             <div style={{ padding: 24, textAlign: 'center', color: '#2a2a2a', fontFamily: 'Space Mono, monospace', fontSize: 11, border: '1px dashed #222', borderRadius: 10, marginBottom: 14 }}>
//               No extra images yet — add one below
//             </div>
//           )}
//           {extraImages.map((ex, idx) => (
//             <ExtraImageEditor key={idx} ex={ex} idx={idx} total={extraImages.length}
//               onChange={updated => updateExtra(idx, updated)}
//               onRemove={() => removeExtra(idx)}
//               onMove={(i, dir) => moveExtra(i, dir)} />
//           ))}
//           <AddExtraImageRow onAdd={newEx => set('extraImages', [...extraImages, newEx])} />
//           {extraImages.length > 0 && (
//             <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
//               <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#555' }}>
//                 {extraImages.filter(e => !e.hidden).length} visible / {extraImages.length} total
//               </span>
//               <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#fb923c', background: '#fb923c14', border: '1px solid #fb923c28', borderRadius: 4, padding: '3px 10px' }}>
//                 {extraImages.length} extra image{extraImages.length !== 1 ? 's' : ''}
//               </span>
//             </div>
//           )}
//         </>
//       )}

//       {/* ══ GENERAL TAB ══ */}
//       {tab === 'General' && (
//         <>
//           <Section label="Scroll pin duration" icon="📌" color="#ff6b6b">
//             <SliderField isMobile={isMobile} label="Pin length" hint="% of viewport height" value={cfg.pinLength} onChange={v => set('pinLength', v)} min={100} max={500} unit="vh%" step={10} />
//           </Section>

//           <Section label="Core image URLs & visibility" icon="🖼" color="#ff6b6b">
//             {[
//               { key: 'img1Url', hiddenKey: 'img1Hidden', label: 'IMG 1 — leads', color: '#c8f04a', placeholder: './rock-bg.png' },
//               { key: 'img2Url', hiddenKey: 'img2Hidden', label: 'IMG 2 — trails', color: '#a78bfa', placeholder: './miss.png' },
//             ].map(({ key, hiddenKey, label, color, placeholder }) => {
//               const isHidden = cfg[hiddenKey] ?? false;
//               return (
//                 <div key={key} style={{
//                   display: 'flex', gap: 12, alignItems: 'flex-start',
//                   marginBottom: 14, padding: 12,
//                   background: '#0a0a0a', borderRadius: 10,
//                   border: `1px solid ${isHidden ? '#1e1e1e' : color + '33'}`,
//                   opacity: isHidden ? 0.6 : 1,
//                   transition: 'all 0.2s ease',
//                 }}>
//                   {/* Thumbnail */}
//                   <div style={{
//                     width: 64, height: 80, flexShrink: 0, borderRadius: 8,
//                     background: '#181818', border: '1px solid #2a2a2a',
//                     overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
//                     position: 'relative',
//                   }}>
//                     {cfg[key] ? (
//                       <img src={cfg[key]} alt="" style={{
//                         width: '100%', height: '100%', objectFit: 'cover',
//                         filter: isHidden ? 'grayscale(1) brightness(0.4)' : 'none',
//                         transition: 'filter 0.2s',
//                       }} onError={e => { e.currentTarget.style.display = 'none'; }} />
//                     ) : null}
//                     {isHidden && (
//                       <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)' }}>
//                         <span style={{ fontSize: 18 }}>🚫</span>
//                       </div>
//                     )}
//                   </div>

//                   <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
//                       <div style={{ padding: '2px 8px', borderRadius: 4, background: color + '22', border: `1px solid ${color}44`, fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.14em', textTransform: 'uppercase' }}>
//                         {label}
//                       </div>
//                       <VisibilityToggle hidden={isHidden} onToggle={() => set(hiddenKey, !isHidden)} label={label} color={color} />
//                     </div>
//                     <input
//                       value={cfg[key]}
//                       onChange={e => set(key, e.target.value)}
//                       placeholder={placeholder}
//                       style={{ background: '#111', border: '1px solid #2a2a2a', borderRadius: 6, color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11, padding: '7px 10px', outline: 'none', width: '100%', boxSizing: 'border-box' }}
//                     />
//                     {isHidden && (
//                       <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#444', background: '#111', borderRadius: 5, padding: '4px 8px', border: '1px solid #1e1e1e' }}>
//                         ⚠ Not rendered on the portfolio frontend
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </Section>

//           <Section label="Config export" icon="📋" color="#ff6b6b">
//             <Text style={{ fontSize: 11, color: '#555', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 10 }}>
//               Copy into Tools.jsx to hard-code values (bypasses Firestore).
//             </Text>
//             <div style={{ background: '#0a0a0a', border: '1px solid #1a1a1a', borderRadius: 8, padding: '12px 14px', fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#c8f04a', lineHeight: 1.7, overflowX: 'auto', maxHeight: 260, overflowY: 'auto' }}>
//               <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
//                 {JSON.stringify(cfg, null, 2)}
//               </pre>
//             </div>
//             <Button size="small" style={{ marginTop: 10, background: '#111', border: '1px solid #333', color: '#aaa' }}
//               onClick={() => { navigator.clipboard.writeText(JSON.stringify(cfg, null, 2)); message.success('Copied to clipboard'); }}>
//               Copy JSON
//             </Button>
//           </Section>
//         </>
//       )}

//       {/* ── Sticky save bar (shows when dirty) ── */}
//       {dirty && (
//         <div style={{
//           position: 'fixed',
//           bottom: 0,
//           left: 0,
//           right: 0,
//           display: 'flex',
//           justifyContent: 'flex-end',
//           alignItems: 'center',
//           gap: 10,
//           padding: isMobile ? '10px 14px' : '12px 24px',
//           background: '#0d0d0d',
//           border: '1px solid #c8f04a33',
//           borderBottom: 'none',
//           borderLeft: 'none',
//           borderRight: 'none',
//           zIndex: 100,
//           backdropFilter: 'blur(8px)',
//         }}>
//           <Text style={{ flex: 1, fontFamily: 'Space Mono, monospace', fontSize: isMobile ? 10 : 11, color: '#c8f04a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//             ● Unsaved changes
//           </Text>
//           <Button size={isMobile ? 'small' : 'middle'} onClick={handleReset}
//             style={{ background: '#111', border: '1px solid #333', color: '#aaa', flexShrink: 0 }}>
//             Discard
//           </Button>
//           <Button type="primary" size={isMobile ? 'small' : 'middle'} icon={<SaveOutlined />}
//             onClick={handleSave} loading={saving}
//             style={{ background: '#c8f04a', border: 'none', color: '#000', fontWeight: 700, flexShrink: 0 }}>
//             {isMobile ? 'Save' : 'Save to Firestore'}
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  Button, Slider, InputNumber, Switch, Divider, Tooltip,
  message, Typography, Space, Spin, Tag, Grid,
} from 'antd';
import {
  SaveOutlined, ReloadOutlined, PictureOutlined,
} from '@ant-design/icons';

// ── Import the upload-store subscription from img.jsx ─────────────────────
// If you can't co-locate the files, paste the subscribeToUploads helper here instead.
import { subscribeToUploads } from './img.jsx';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

// ── Firestore REST ────────────────────────────────────────────────────────
const PROJECT_ID = 'portfolio-e79b8-5854c';
const API_KEY    = 'AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc';
const REST_BASE  = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents`;
const DOC_PATH   = `${REST_BASE}/imageConfig/tools?key=${API_KEY}`;

function toValue(v) {
  if (v === null || v === undefined) return { nullValue: null };
  if (typeof v === 'boolean')  return { booleanValue: v };
  if (typeof v === 'number')   return Number.isInteger(v) ? { integerValue: String(v) } : { doubleValue: v };
  if (typeof v === 'string')   return { stringValue: v };
  if (Array.isArray(v))        return { arrayValue: { values: v.map(toValue) } };
  if (typeof v === 'object')   return { mapValue: { fields: toFields(v) } };
  return { stringValue: String(v) };
}
function toFields(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) out[k] = toValue(v);
  return out;
}
function fromValue(v) {
  if (!v) return null;
  if ('stringValue'  in v) return v.stringValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue'  in v) return Number(v.doubleValue);
  if ('booleanValue' in v) return v.booleanValue;
  if ('nullValue'    in v) return null;
  if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
  if ('mapValue'     in v) return fromFields(v.mapValue.fields || {});
  return null;
}
function fromFields(fields) {
  const obj = {};
  for (const [k, v] of Object.entries(fields)) obj[k] = fromValue(v);
  return obj;
}

async function loadConfig() {
  const res = await fetch(DOC_PATH);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Firestore GET failed: ${res.status}`);
  const json = await res.json();
  return fromFields(json.fields || {});
}
async function saveConfig(data) {
  const fieldPaths = Object.keys(data).map(k => `updateMask.fieldPaths=${encodeURIComponent(k)}`).join('&');
  const url = `${REST_BASE}/imageConfig/tools?${fieldPaths}&key=${API_KEY}`;
  const res = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fields: toFields(data) }),
  });
  if (!res.ok) throw new Error(`Firestore PATCH failed: ${res.status}`);
  return res.json();
}

// ── helpers ───────────────────────────────────────────────────────────────
const IMAGE_EXTS = ['png','jpg','jpeg','gif','webp','avif','svg'];
function isImageUrl(url = '') {
  const ext = url.split('?')[0].split('.').pop().toLowerCase();
  return IMAGE_EXTS.includes(ext);
}

// ── Default extra-image object ────────────────────────────────────────────
const EXTRA_IMAGE_DEFAULTS = {
  url:               '',
  hidden:            false,
  label:             'Extra image',
  startX_desktop:   -30,
  startY_desktop:    90,
  startX_mobile:    -60,
  startY_mobile:     80,
  endX_desktop:      95,
  endY_desktop:     -95,
  endX_mobile:      100,
  endY_mobile:      -90,
  trail:             0.45,
  img2FadeStart:     0.1,
  rot2InitOffset:    -18,
  pA_desktop:        0.22,
  pB_desktop:        0.62,
  rot2AtA_desktop:   -40,
  rot2AtB_desktop:   -30,
  pA_mobile:         0.48,
  pB_mobile:         0.52,
  rot2AtA_mobile:    -60,
  rot2AtB_mobile:    -60,
  widthVw_desktop:   20,
  widthVw_mobile:    44,
  zIndex:            8,
};

const DEFAULTS = {
  textOverline:   'Philosophy',
  textLine1:      'Craft over',
  textLine2:      'shortcuts.',
  textLine3:      'Always.',
  textLine1Color: '#f0ece4',
  textLine2Color: 'var(--acid, #c8f04a)',
  textLine3Color: '#f0ece4',
  textSub: 'I believe great digital products are built through attention to detail, thoughtful design, and clean engineering. Every project is an opportunity to create experiences that are fast, intuitive, and meaningful. Rather than chasing trends, I focus on building solutions that are reliable, scalable, and crafted to deliver real value.',

  img1StartX_desktop:   -30,
  img1StartY_desktop:    90,
  img1StartRot:         -12,
  img1EndX_desktop:      95,
  img1EndY_desktop:     -95,
  img1EndRot:            10,
  img1pA_desktop:        0.0,
  img1pB_desktop:        0.0,
  img1RotAtA_desktop:   -12,
  img1RotAtB_desktop:    10,

  img1StartX_mobile:    -60,
  img1StartY_mobile:     80,
  img1EndX_mobile:      100,
  img1EndY_mobile:      -90,
  img1pA_mobile:         0.0,
  img1pB_mobile:         0.0,
  img1RotAtA_mobile:    -12,
  img1RotAtB_mobile:     10,

  trail:                0.38,
  rot2InitOffset:      -18,
  pA_desktop:           0.22,
  pB_desktop:           0.62,
  rot2AtA_desktop:     -40,
  rot2AtB_desktop:     -30,
  pA_mobile:            0.48,
  pB_mobile:            0.52,
  rot2AtA_mobile:      -60,
  rot2AtB_mobile:      -60,

  pinLength:           220,

  img1Width_desktop:    24,
  img1Width_mobile:     52,
  img2Width_desktop:    20,
  img2Width_mobile:     44,

  img1Url: './rock-bg.png',
  img2Url: './miss.png',

  img1Hidden: false,
  img2Hidden: false,

  extraImages: [],
  img2FadeStart: 0.1,
};

function safeArray(val) { return Array.isArray(val) ? val : []; }
function mergeExtra(raw) {
  if (typeof raw === 'string') return { ...EXTRA_IMAGE_DEFAULTS, url: raw };
  return { ...EXTRA_IMAGE_DEFAULTS, ...raw };
}

// ═══════════════════════════════════════════════════════════════════════════
// ── Uploaded Images Picker ────────────────────────────────────────────────
// ═══════════════════════════════════════════════════════════════════════════
function UploadedImagesPicker({ onSelect, activeUrl = '' }) {
  const [uploads, setUploads] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const unsub = subscribeToUploads(setUploads);
    return unsub;
  }, []);

  // Only show image uploads (not videos/PDFs)
  const images = uploads.filter(u => isImageUrl(u.url));

  if (images.length === 0) return null;

  return (
    <div style={{ marginTop: 6 }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '5px 10px', borderRadius: 7,
          border: '1px solid #2a2a2a',
          background: open ? '#1a1a00' : '#111',
          color: open ? '#c8f04a' : '#555',
          fontFamily: 'Space Mono, monospace', fontSize: 10,
          letterSpacing: '0.12em', textTransform: 'uppercase',
          cursor: 'pointer', transition: 'all 0.16s',
        }}
      >
        <PictureOutlined />
        {open ? 'Close picker' : `Pick from uploads (${images.length})`}
      </button>

      {open && (
        <div style={{
          marginTop: 8, padding: 10,
          background: '#080808', borderRadius: 10,
          border: '1px solid #1e1e1e',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))',
          gap: 8,
          maxHeight: 260, overflowY: 'auto',
        }}>
          {images.map(img => {
            const active = img.url === activeUrl;
            return (
              <button
                key={img.key}
                title={img.name}
                onClick={() => { onSelect(img.url); setOpen(false); }}
                style={{
                  padding: 0, border: active ? '2px solid #c8f04a' : '2px solid transparent',
                  borderRadius: 8, overflow: 'hidden', cursor: 'pointer',
                  background: '#111', transition: 'border-color 0.15s',
                  display: 'flex', flexDirection: 'column', alignItems: 'stretch',
                }}
              >
                <img
                  src={img.url}
                  alt={img.name}
                  style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block' }}
                  onError={e => { e.currentTarget.style.background = '#222'; e.currentTarget.style.display = 'block'; }}
                />
                <div style={{
                  padding: '2px 4px',
                  fontFamily: 'Space Mono, monospace', fontSize: 8,
                  color: active ? '#c8f04a' : '#444',
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                  textAlign: 'left', background: '#0a0a0a',
                }}>
                  {img.name}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// UI primitives
// ═══════════════════════════════════════════════════════════════════════════

function Section({ label, icon, color = '#c8f04a', children, collapsible = false }) {
  const [open, setOpen] = useState(true);
  return (
    <div style={{
      background: '#111',
      border: '1px solid #222',
      borderRadius: 12,
      padding: '16px',
      marginBottom: 16,
    }}>
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 10, marginBottom: open ? 16 : 0,
          cursor: collapsible ? 'pointer' : 'default',
        }}
        onClick={collapsible ? () => setOpen(o => !o) : undefined}
      >
        <span style={{ fontSize: 16 }}>{icon}</span>
        <Text style={{
          fontFamily: 'Space Mono, monospace', fontSize: 11,
          letterSpacing: '0.22em', textTransform: 'uppercase', color,
        }}>
          {label}
        </Text>
        {collapsible && (
          <span style={{ marginLeft: 'auto', color: '#444', fontSize: 12 }}>
            {open ? '▲' : '▼'}
          </span>
        )}
      </div>
      {open && children}
    </div>
  );
}

function Field({ label, hint, children, isMobile }) {
  if (isMobile) {
    return (
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 6 }}>
          <Text style={{ fontSize: 12, color: '#aaa', fontFamily: 'Space Mono, monospace' }}>
            {label}
          </Text>
          {hint && <div><Text style={{ fontSize: 10, color: '#444' }}>{hint}</Text></div>}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {children}
        </div>
      </div>
    );
  }
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '180px 1fr auto',
      alignItems: 'center',
      gap: 16, marginBottom: 14, minHeight: 36,
    }}>
      <div>
        <Text style={{ fontSize: 13, color: '#aaa', fontFamily: 'Space Mono, monospace' }}>
          {label}
        </Text>
        {hint && <div><Text style={{ fontSize: 11, color: '#444' }}>{hint}</Text></div>}
      </div>
      {children}
    </div>
  );
}

function SliderField({ label, hint, value, onChange, min, max, step = 1, unit = '', isMobile }) {
  if (isMobile) {
    return (
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <Text style={{ fontSize: 11, color: '#aaa', fontFamily: 'Space Mono, monospace' }}>{label}</Text>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <InputNumber
              size="small" min={min} max={max} step={step} value={value}
              onChange={v => v !== null && onChange(v)}
              style={{ width: 64, background: '#0a0a0a', border: '1px solid #333', color: '#c8f04a', fontFamily: 'Space Mono, monospace', fontSize: 11 }}
            />
            {unit && <Text style={{ fontSize: 10, color: '#555', fontFamily: 'Space Mono, monospace' }}>{unit}</Text>}
          </div>
        </div>
        {hint && <Text style={{ fontSize: 10, color: '#444', display: 'block', marginBottom: 4 }}>{hint}</Text>}
        <Slider
          min={min} max={max} step={step} value={value} onChange={onChange}
          styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }}
        />
      </div>
    );
  }
  return (
    <Field label={label} hint={hint}>
      <Slider
        min={min} max={max} step={step} value={value} onChange={onChange}
        styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 90 }}>
        <InputNumber
          size="small" min={min} max={max} step={step} value={value}
          onChange={v => v !== null && onChange(v)}
          style={{ width: 72, background: '#0a0a0a', border: '1px solid #333', color: '#c8f04a', fontFamily: 'Space Mono, monospace', fontSize: 12 }}
        />
        {unit && <Text style={{ fontSize: 11, color: '#555', fontFamily: 'Space Mono, monospace' }}>{unit}</Text>}
      </div>
    </Field>
  );
}

function TextInput({ label, hint, value, onChange, multiline = false, placeholder = '', isMobile }) {
  const base = {
    width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a',
    borderRadius: 6, color: '#f0ece4', fontFamily: 'Space Mono, monospace',
    fontSize: 12, padding: '7px 10px', outline: 'none',
    boxSizing: 'border-box', resize: multiline ? 'vertical' : 'none',
  };

  if (isMobile) {
    return (
      <div style={{ marginBottom: 14 }}>
        <Text style={{ fontSize: 12, color: '#aaa', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 6 }}>{label}</Text>
        {hint && <Text style={{ fontSize: 10, color: '#444', display: 'block', marginBottom: 4 }}>{hint}</Text>}
        {multiline ? (
          <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} rows={3} style={base} />
        ) : (
          <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={base} />
        )}
      </div>
    );
  }

  return (
    <Field label={label} hint={hint}>
      {multiline ? (
        <textarea
          value={value} onChange={e => onChange(e.target.value)}
          placeholder={placeholder} rows={3}
          style={{ ...base, gridColumn: '1 / -1' }}
        />
      ) : (
        <input
          value={value} onChange={e => onChange(e.target.value)}
          placeholder={placeholder} style={base}
        />
      )}
      <div />
    </Field>
  );
}

function ColorField({ label, hint, value, onChange, isMobile }) {
  const inner = (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flex: 1 }}>
      <input
        type="color"
        value={value.startsWith('#') ? value : '#c8f04a'}
        onChange={e => onChange(e.target.value)}
        style={{ width: 36, height: 32, border: '1px solid #333', borderRadius: 4, background: '#0a0a0a', cursor: 'pointer', flexShrink: 0 }}
      />
      <input
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="#f0ece4 or var(--acid, #c8f04a)"
        style={{
          flex: 1, background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: 6,
          color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11,
          padding: '7px 10px', outline: 'none', minWidth: 0,
        }}
      />
    </div>
  );

  if (isMobile) {
    return (
      <div style={{ marginBottom: 14 }}>
        <Text style={{ fontSize: 12, color: '#aaa', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 6 }}>{label}</Text>
        {inner}
      </div>
    );
  }

  return (
    <Field label={label} hint={hint}>
      {inner}
      <div />
    </Field>
  );
}

// ── TabBar ────────────────────────────────────────────────────────────────
function TabBar({ active, onChange, isMobile }) {
  const tabs = ['Text', 'Desktop', 'Mobile', 'Img1 Curve', 'Image 2', 'Extras', 'General'];
  const tabsFull = ['Text', 'Desktop', 'Mobile', 'Image 1 Curve', 'Image 2', 'Extra Images', 'General'];
  const colors = {
    'Text': '#ffd666', 'Desktop': '#c8f04a', 'Mobile': '#00e5ff',
    'Img1 Curve': '#86efac', 'Image 1 Curve': '#86efac',
    'Image 2': '#a78bfa', 'Extras': '#fb923c', 'Extra Images': '#fb923c',
    'General': '#ff6b6b',
  };

  const activeNorm = active
    .replace('Image 1 Curve', 'Img1 Curve')
    .replace('Extra Images', 'Extras');

  const displayTabs = isMobile ? tabs : tabsFull;

  const handleClick = (t) => {
    const full = { 'Img1 Curve': 'Image 1 Curve', 'Extras': 'Extra Images' };
    onChange(full[t] || t);
  };

  if (isMobile) {
    return (
      <div style={{
        display: 'flex', overflowX: 'auto', gap: 4, marginBottom: 16,
        background: '#111', padding: 4, borderRadius: 10, border: '1px solid #222',
        WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none',
      }}>
        {displayTabs.map(t => {
          const isActive = activeNorm === t || active === t;
          return (
            <button key={t} onClick={() => handleClick(t)} style={{
              flexShrink: 0, padding: '8px 12px', borderRadius: 8, border: 'none',
              cursor: 'pointer', fontFamily: 'Space Mono, monospace', fontSize: 9,
              letterSpacing: '0.1em', textTransform: 'uppercase',
              background: isActive ? colors[t] : 'transparent',
              color: isActive ? '#000' : '#555',
              transition: 'all 0.18s ease', fontWeight: isActive ? 700 : 400, whiteSpace: 'nowrap',
            }}>
              {t}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 20,
      background: '#111', padding: 4, borderRadius: 10, border: '1px solid #222',
    }}>
      {displayTabs.map(t => (
        <button key={t} onClick={() => onChange(t)} style={{
          flex: '1 1 auto', padding: '8px 10px', borderRadius: 8, border: 'none',
          cursor: 'pointer', fontFamily: 'Space Mono, monospace', fontSize: 10,
          letterSpacing: '0.1em', textTransform: 'uppercase',
          background: active === t ? colors[t] : 'transparent',
          color: active === t ? '#000' : '#555',
          transition: 'all 0.18s ease', fontWeight: active === t ? 700 : 400,
        }}>
          {t}
        </button>
      ))}
    </div>
  );
}

// ── Motion preview ────────────────────────────────────────────────────────
function MotionPreview({ cfg, progress = 0.5, extraImages = [] }) {
  const containerRef = useRef(null);
  const [W, setW] = useState(320);
  const H = Math.round(W * (180 / 320));

  useEffect(() => {
    if (!containerRef.current) return;
    const ro = new ResizeObserver(entries => {
      for (const e of entries) setW(Math.floor(e.contentRect.width));
    });
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const vw = v => (v / 100) * W;
  const vh = v => (v / 100) * H;

  function smooth(t) { return t * t * (3 - 2 * t); }
  function computeRot(p, rotStart, pA, pB, rotAtA, rotAtB) {
    if (p <= pA) {
      const t = pA === 0 ? 1 : p / pA;
      return rotStart + (rotAtA - rotStart) * smooth(t);
    }
    if (p <= pB) {
      const t = (pB === pA) ? 1 : (p - pA) / (pB - pA);
      return rotAtA + (rotAtB - rotAtA) * smooth(t);
    }
    return rotAtB;
  }

  const x1s = vw(cfg.img1StartX_desktop), y1s = vh(cfg.img1StartY_desktop);
  const x1e = vw(cfg.img1EndX_desktop),   y1e = vh(cfg.img1EndY_desktop);
  const cx  = W / 2, cy = H / 2;

  const x1 = x1s + (x1e - x1s) * progress + cx;
  const y1 = y1s + (y1e - y1s) * progress + cy;
  const rot1 = (cfg.img1pA_desktop === 0 && cfg.img1pB_desktop === 0)
    ? cfg.img1StartRot + (cfg.img1EndRot - cfg.img1StartRot) * progress
    : computeRot(progress, cfg.img1StartRot, cfg.img1pA_desktop, cfg.img1pB_desktop, cfg.img1RotAtA_desktop, cfg.img1RotAtB_desktop);

  const trail = cfg.trail || 0.38;
  const p2 = Math.max(0, progress - trail) / (1 - trail);
  const x2 = x1s + (x1e - x1s) * p2 + cx;
  const y2 = y1s + (y1e - y1s) * p2 + cy;
  const op2 = Math.min(1, p2 / Math.max(cfg.img2FadeStart || 0.1, 0.001));
  const rot2Start = cfg.img1StartRot + (cfg.rot2InitOffset || -18);
  const rot2 = computeRot(p2, rot2Start, cfg.pA_desktop || 0.22, cfg.pB_desktop || 0.62, cfg.rot2AtA_desktop || -40, cfg.rot2AtB_desktop || -30);

  const imgW = Math.max(20, W * 0.11);
  const imgH = Math.round(imgW * 1.44);

  const extraBoxes = extraImages.filter(ex => !ex.hidden && ex.url).map((ex, i) => {
    const exTrail  = ex.trail ?? 0.45;
    const pEx      = Math.max(0, progress - exTrail) / (1 - exTrail);
    const opEx     = Math.min(1, pEx / Math.max(ex.img2FadeStart ?? 0.1, 0.001));
    const exRotStart = cfg.img1StartRot + (ex.rot2InitOffset ?? -18);
    const exRot    = computeRot(pEx, exRotStart, ex.pA_desktop ?? 0.22, ex.pB_desktop ?? 0.62, ex.rot2AtA_desktop ?? -40, ex.rot2AtB_desktop ?? -30);
    const exXs = vw(ex.startX_desktop ?? -30), exYs = vh(ex.startY_desktop ?? 90);
    const exXe = vw(ex.endX_desktop   ??  95), exYe = vh(ex.endY_desktop   ?? -95);
    const exX  = exXs + (exXe - exXs) * pEx + cx;
    const exY  = exYs + (exYe - exYs) * pEx + cy;
    return { exX, exY, exRot, opEx, label: ex.label || `+${i + 1}`, i };
  });

  const colors = ['#fb923c', '#f472b6', '#34d399', '#60a5fa', '#facc15'];

  return (
    <div ref={containerRef} style={{ background: '#000', border: '1px solid #222', borderRadius: 10, overflow: 'hidden', marginBottom: 16, width: '100%' }}>
      <div style={{ padding: '6px 12px', borderBottom: '1px solid #1a1a1a', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
        <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
          Motion preview
        </Text>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {cfg.img1Hidden && <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 8, color: '#444', background: '#1a1a1a', borderRadius: 3, padding: '1px 5px' }}>IMG1 HIDDEN</span>}
          {cfg.img2Hidden && <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 8, color: '#444', background: '#1a1a1a', borderRadius: 3, padding: '1px 5px' }}>IMG2 HIDDEN</span>}
          <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#c8f04a' }}>{Math.round(progress * 100)}% scroll</Text>
        </div>
      </div>
      <svg width={W} height={H} style={{ display: 'block' }}>
        {[...Array(7)].map((_, i) => <line key={`v${i}`} x1={i * W / 6} y1={0} x2={i * W / 6} y2={H} stroke="#111" strokeWidth={0.5} />)}
        {[...Array(5)].map((_, i) => <line key={`h${i}`} x1={0} y1={i * H / 4} x2={W} y2={i * H / 4} stroke="#111" strokeWidth={0.5} />)}
        <line x1={x1s + cx} y1={y1s + cy} x2={x1e + cx} y2={y1e + cy} stroke="#1a1a1a" strokeWidth={1} strokeDasharray="4 4" />

        {extraBoxes.map(({ exX, exY, exRot, opEx, label, i }) => {
          const color = colors[i % colors.length];
          const visEx = extraImages.filter(e => !e.hidden && e.url)[i];
          const exXs2 = vw(visEx?.startX_desktop ?? -30);
          const exYs2 = vh(visEx?.startY_desktop ?? 90);
          const exXe2 = vw(visEx?.endX_desktop   ?? 95);
          const exYe2 = vh(visEx?.endY_desktop   ?? -95);
          return (
            <g key={i}>
              <line x1={exXs2 + cx} y1={exYs2 + cy} x2={exXe2 + cx} y2={exYe2 + cy}
                stroke={color} strokeWidth={0.5} strokeDasharray="3 4" strokeOpacity={0.2} />
              <g transform={`translate(${exX},${exY}) rotate(${exRot})`} opacity={opEx}>
                <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
                  fill={color} fillOpacity={0.15} stroke={color} strokeWidth={1} strokeOpacity={0.5} />
                <text x={0} y={4} textAnchor="middle" fill={color} fontSize={Math.max(6, imgW * 0.18)} fontFamily="Space Mono, monospace">{label}</text>
              </g>
            </g>
          );
        })}

        {!cfg.img2Hidden && (
          <g transform={`translate(${x2},${y2}) rotate(${rot2})`} opacity={op2}>
            <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
              fill="#a78bfa" fillOpacity={0.25} stroke="#a78bfa" strokeWidth={1} strokeOpacity={0.5} />
            <text x={0} y={4} textAnchor="middle" fill="#a78bfa" fontSize={Math.max(6, imgW * 0.18)} fontFamily="Space Mono, monospace">IMG 2</text>
          </g>
        )}
        {cfg.img2Hidden && (
          <g transform={`translate(${x2},${y2}) rotate(${rot2})`} opacity={0.15}>
            <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
              fill="transparent" stroke="#333" strokeWidth={1} strokeDasharray="3 3" />
            <text x={0} y={4} textAnchor="middle" fill="#333" fontSize={Math.max(5, imgW * 0.15)} fontFamily="Space Mono, monospace">HIDDEN</text>
          </g>
        )}

        {!cfg.img1Hidden && (
          <g transform={`translate(${x1},${y1}) rotate(${rot1})`}>
            <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
              fill="#c8f04a" fillOpacity={0.2} stroke="#c8f04a" strokeWidth={1.5} />
            <text x={0} y={4} textAnchor="middle" fill="#c8f04a" fontSize={Math.max(6, imgW * 0.18)} fontFamily="Space Mono, monospace">IMG 1</text>
          </g>
        )}
        {cfg.img1Hidden && (
          <g transform={`translate(${x1},${y1}) rotate(${rot1})`} opacity={0.15}>
            <rect x={-imgW / 2} y={-imgH / 2} width={imgW} height={imgH} rx={3}
              fill="transparent" stroke="#444" strokeWidth={1} strokeDasharray="3 3" />
            <text x={0} y={4} textAnchor="middle" fill="#444" fontSize={Math.max(5, imgW * 0.15)} fontFamily="Space Mono, monospace">HIDDEN</text>
          </g>
        )}

        <line x1={cx - 6} y1={cy} x2={cx + 6} y2={cy} stroke="#333" strokeWidth={0.5} />
        <line x1={cx} y1={cy - 6} x2={cx} y2={cy + 6} stroke="#333" strokeWidth={0.5} />
      </svg>
    </div>
  );
}

// ── MiniSlider ────────────────────────────────────────────────────────────
function MiniSlider({ label, value, onChange, min, max, step, unit = '' }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
        <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#666' }}>{label}</Text>
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <InputNumber size="small" min={min} max={max} step={step} value={value}
            onChange={v => v !== null && onChange(v)}
            style={{ width: 52, background: '#0a0a0a', border: '1px solid #2a2a2a', color: '#c8f04a', fontFamily: 'Space Mono, monospace', fontSize: 10 }}
          />
          {unit && <Text style={{ fontSize: 9, color: '#444', fontFamily: 'Space Mono, monospace' }}>{unit}</Text>}
        </div>
      </div>
      <Slider min={min} max={max} step={step} value={value} onChange={onChange}
        styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }} />
    </div>
  );
}

// ── ExtraImageEditor ──────────────────────────────────────────────────────
function ExtraImageEditor({ ex, idx, total, onChange, onRemove, onMove }) {
  const [open, setOpen] = useState(false);
  const [posTab, setPosTab] = useState('desktop');
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const colors = ['#fb923c', '#f472b6', '#34d399', '#60a5fa', '#facc15'];
  const color = colors[idx % colors.length];

  const set = (key, val) => onChange({ ...ex, [key]: val });

  const posBtnStyle = (active) => ({
    padding: '3px 10px', borderRadius: 4, border: 'none', cursor: 'pointer',
    fontFamily: 'Space Mono, monospace', fontSize: 9,
    letterSpacing: '0.1em', textTransform: 'uppercase',
    background: active ? color + '22' : 'transparent',
    color: active ? color : '#444',
    transition: 'all 0.15s',
  });

  const presetBtnStyle = {
    padding: '3px 8px', borderRadius: 4, border: '1px solid #1e1e1e',
    background: '#111', color: '#555', fontFamily: 'Space Mono, monospace',
    fontSize: 9, cursor: 'pointer', letterSpacing: '0.05em', transition: 'all 0.12s',
  };

  return (
    <div style={{
      background: '#0a0a0a',
      border: `1px solid ${ex.hidden ? '#1a1a1a' : color + '44'}`,
      borderRadius: 10, marginBottom: 10, overflow: 'hidden',
      opacity: ex.hidden ? 0.5 : 1, transition: 'opacity 0.2s',
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '52px 1fr auto' : '64px 1fr auto',
        alignItems: 'center', gap: 10, padding: '10px 12px',
      }}>
        <div style={{
          width: isMobile ? 52 : 64, height: isMobile ? 66 : 80,
          borderRadius: 6, background: '#181818', border: '1px solid #252525',
          overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {ex.url ? (
            <img src={ex.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={e => { e.currentTarget.style.display = 'none'; }} />
          ) : (
            <span style={{ color: '#2a2a2a', fontSize: 16 }}>?</span>
          )}
        </div>

        <div style={{ minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 5, flexWrap: 'wrap' }}>
            <span style={{
              fontFamily: 'Space Mono, monospace', fontSize: 9, color,
              background: color + '18', border: `1px solid ${color}33`,
              borderRadius: 3, padding: '1px 5px', whiteSpace: 'nowrap',
            }}>#{String(idx + 1).padStart(2, '0')}</span>
            {ex.hidden && (
              <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 8, color: '#555', background: '#1a1a1a', borderRadius: 3, padding: '1px 5px' }}>HIDDEN</span>
            )}
          </div>
          <input
            value={ex.label || ''}
            onChange={e => set('label', e.target.value)}
            placeholder="Label (optional)"
            style={{
              width: '100%', background: '#111', border: '1px solid #1e1e1e', borderRadius: 5,
              color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11,
              padding: '4px 7px', outline: 'none', boxSizing: 'border-box', marginBottom: 4,
            }}
          />
          <input
            value={ex.url || ''}
            onChange={e => set('url', e.target.value)}
            placeholder="https://... or ./image.png"
            style={{
              width: '100%', background: '#111', border: '1px solid #1e1e1e', borderRadius: 5,
              color: '#888', fontFamily: 'Space Mono, monospace', fontSize: 10,
              padding: '4px 7px', outline: 'none', boxSizing: 'border-box',
            }}
          />
          {/* ── Uploaded images picker for extra image ── */}
          <UploadedImagesPicker
            activeUrl={ex.url}
            onSelect={url => set('url', url)}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
          {[
            { title: ex.hidden ? 'Show' : 'Hide', icon: ex.hidden ? '👁' : '✓', bg: ex.hidden ? '#1a1a1a' : '#0d2010', fg: ex.hidden ? '#444' : '#4ade80', onClick: () => set('hidden', !ex.hidden), border: 'none' },
            { title: 'Settings', icon: '⚙', bg: open ? color + '18' : '#111', fg: open ? color : '#444', onClick: () => setOpen(o => !o), border: `1px solid ${open ? color + '66' : '#222'}` },
            { title: 'Move up', icon: '↑', bg: '#111', fg: idx === 0 ? '#2a2a2a' : '#888', onClick: () => onMove(idx, -1), border: '1px solid #222', disabled: idx === 0 },
            { title: 'Move down', icon: '↓', bg: '#111', fg: idx === total - 1 ? '#2a2a2a' : '#888', onClick: () => onMove(idx, 1), border: '1px solid #222', disabled: idx === total - 1 },
            { title: 'Remove', icon: '×', bg: '#1a0808', fg: '#ff6b6b', onClick: onRemove, border: '1px solid #3a1515' },
          ].map((btn, bi) => (
            <button key={bi} title={btn.title} onClick={btn.onClick} disabled={btn.disabled}
              style={{
                width: 28, height: 28, borderRadius: 6, border: btn.border, cursor: btn.disabled ? 'default' : 'pointer',
                background: btn.bg, color: btn.fg, fontSize: 13,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
              {btn.icon}
            </button>
          ))}
        </div>
      </div>

      {open && (
        <div style={{ borderTop: '1px solid #1a1a1a', padding: '14px 14px', background: '#080808' }}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 6 }}>
              <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase' }}>
                Position
              </Text>
              <div style={{ display: 'flex', gap: 2, background: '#111', borderRadius: 5, padding: 2, border: '1px solid #1e1e1e' }}>
                <button style={posBtnStyle(posTab === 'desktop')} onClick={() => setPosTab('desktop')}>Desktop</button>
                <button style={posBtnStyle(posTab === 'mobile')}  onClick={() => setPosTab('mobile')}>Mobile</button>
              </div>
            </div>

            {posTab === 'desktop' && (
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
                <div>
                  <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>Start</div>
                  <MiniSlider label="Start X" value={ex.startX_desktop ?? -30} onChange={v => set('startX_desktop', v)} min={-150} max={150} step={1} unit="vw" />
                  <MiniSlider label="Start Y" value={ex.startY_desktop ??  90} onChange={v => set('startY_desktop', v)} min={-150} max={200} step={1} unit="vh" />
                </div>
                <div>
                  <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>End</div>
                  <MiniSlider label="End X" value={ex.endX_desktop ??  95} onChange={v => set('endX_desktop', v)} min={-150} max={200} step={1} unit="vw" />
                  <MiniSlider label="End Y" value={ex.endY_desktop ?? -95} onChange={v => set('endY_desktop', v)} min={-200} max={200} step={1} unit="vh" />
                </div>
              </div>
            )}

            {posTab === 'mobile' && (
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
                <div>
                  <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>Start</div>
                  <MiniSlider label="Start X" value={ex.startX_mobile ?? -60} onChange={v => set('startX_mobile', v)} min={-150} max={150} step={1} unit="vw" />
                  <MiniSlider label="Start Y" value={ex.startY_mobile ??  80} onChange={v => set('startY_mobile', v)} min={-150} max={200} step={1} unit="vh" />
                </div>
                <div>
                  <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#555', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 6, borderLeft: `2px solid ${color}44`, paddingLeft: 6 }}>End</div>
                  <MiniSlider label="End X" value={ex.endX_mobile   ?? 100} onChange={v => set('endX_mobile', v)} min={-150} max={200} step={1} unit="vw" />
                  <MiniSlider label="End Y" value={ex.endY_mobile   ?? -90} onChange={v => set('endY_mobile', v)} min={-200} max={200} step={1} unit="vh" />
                </div>
              </div>
            )}

            {['start', 'end'].map(type => (
              <div key={type} style={{ marginTop: 10 }}>
                <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 9, color: '#444', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 6 }}>
                  Quick {type} presets ({posTab})
                </Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {(type === 'start' ? [
                    { label: '↙ BL',  sx: -30, sy:  90 },
                    { label: '↓ BM',  sx:   0, sy:  90 },
                    { label: '↘ BR',  sx:  80, sy:  90 },
                    { label: '← ML',  sx: -60, sy:   0 },
                    { label: '✦ C',   sx:   0, sy:   0 },
                    { label: '→ MR',  sx:  80, sy:   0 },
                    { label: '↖ TL',  sx: -30, sy: -90 },
                    { label: '↑ TM',  sx:   0, sy: -90 },
                    { label: '↗ TR',  sx:  80, sy: -90 },
                  ] : [
                    { label: '↙ BL',  ex_: -30, ey:  90 },
                    { label: '↓ BM',  ex_:   0, ey:  90 },
                    { label: '↘ BR',  ex_:  80, ey:  90 },
                    { label: '← ML',  ex_: -60, ey:   0 },
                    { label: '✦ C',   ex_:   0, ey:   0 },
                    { label: '→ MR',  ex_:  80, ey:   0 },
                    { label: '↖ TL',  ex_: -30, ey: -90 },
                    { label: '↑ TM',  ex_:  50, ey: -95 },
                    { label: '↗ TR',  ex_:  95, ey: -95 },
                  ]).map(preset => (
                    <button key={preset.label}
                      onClick={() => {
                        if (type === 'start') {
                          if (posTab === 'desktop') onChange({ ...ex, startX_desktop: preset.sx, startY_desktop: preset.sy });
                          else onChange({ ...ex, startX_mobile: preset.sx, startY_mobile: preset.sy });
                        } else {
                          if (posTab === 'desktop') onChange({ ...ex, endX_desktop: preset.ex_, endY_desktop: preset.ey });
                          else onChange({ ...ex, endX_mobile: preset.ex_, endY_mobile: preset.ey });
                        }
                      }}
                      style={presetBtnStyle}
                      onMouseEnter={e => { e.currentTarget.style.color = color; e.currentTarget.style.borderColor = color + '55'; }}
                      onMouseLeave={e => { e.currentTarget.style.color = '#555'; e.currentTarget.style.borderColor = '#1e1e1e'; }}
                    >{preset.label}</button>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <Divider style={{ borderColor: '#1a1a1a', margin: '4px 0 14px' }} />

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
            <div>
              <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Trail &amp; Fade</Text>
              <MiniSlider label="Trail" value={ex.trail ?? 0.45} onChange={v => set('trail', v)} min={0} max={0.95} step={0.01} />
              <MiniSlider label="Fade window" value={ex.img2FadeStart ?? 0.1} onChange={v => set('img2FadeStart', v)} min={0.01} max={0.5} step={0.01} />
              <MiniSlider label="Init rot offset" value={ex.rot2InitOffset ?? -18} onChange={v => set('rot2InitOffset', v)} min={-90} max={90} step={1} unit="°" />
              <Divider style={{ borderColor: '#1a1a1a', margin: '8px 0' }} />
              <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Sizes</Text>
              <MiniSlider label="Width desktop" value={ex.widthVw_desktop ?? 20} onChange={v => set('widthVw_desktop', v)} min={5} max={60} step={1} unit="vw" />
              <MiniSlider label="Width mobile" value={ex.widthVw_mobile ?? 44} onChange={v => set('widthVw_mobile', v)} min={5} max={80} step={1} unit="vw" />
              <MiniSlider label="Z-index" value={ex.zIndex ?? 8} onChange={v => set('zIndex', v)} min={1} max={20} step={1} />
            </div>
            <div>
              <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Rot curve — desktop</Text>
              <MiniSlider label="Point A" value={ex.pA_desktop ?? 0.22} onChange={v => set('pA_desktop', v)} min={0} max={1} step={0.01} />
              <MiniSlider label="Point B" value={ex.pB_desktop ?? 0.62} onChange={v => set('pB_desktop', v)} min={0} max={1} step={0.01} />
              <MiniSlider label="Rot at A" value={ex.rot2AtA_desktop ?? -40} onChange={v => set('rot2AtA_desktop', v)} min={-180} max={180} step={1} unit="°" />
              <MiniSlider label="Rot at B" value={ex.rot2AtB_desktop ?? -30} onChange={v => set('rot2AtB_desktop', v)} min={-180} max={180} step={1} unit="°" />
              <Divider style={{ borderColor: '#1a1a1a', margin: '8px 0' }} />
              <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>Rot curve — mobile</Text>
              <MiniSlider label="Point A" value={ex.pA_mobile ?? 0.48} onChange={v => set('pA_mobile', v)} min={0} max={1} step={0.01} />
              <MiniSlider label="Point B" value={ex.pB_mobile ?? 0.52} onChange={v => set('pB_mobile', v)} min={0} max={1} step={0.01} />
              <MiniSlider label="Rot at A" value={ex.rot2AtA_mobile ?? -60} onChange={v => set('rot2AtA_mobile', v)} min={-180} max={180} step={1} unit="°" />
              <MiniSlider label="Rot at B" value={ex.rot2AtB_mobile ?? -60} onChange={v => set('rot2AtB_mobile', v)} min={-180} max={180} step={1} unit="°" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── AddExtraImageRow ──────────────────────────────────────────────────────
function AddExtraImageRow({ onAdd }) {
  const [val, setVal] = useState('');
  const [label, setLabel] = useState('');
  const [preview, setPreview] = useState(false);

  const commit = () => {
    const trimmed = val.trim();
    if (!trimmed) return;
    onAdd({ ...EXTRA_IMAGE_DEFAULTS, url: trimmed, label: label.trim() || 'Extra image' });
    setVal(''); setLabel(''); setPreview(false);
  };

  const inputStyle = {
    background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: 5,
    color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11,
    padding: '5px 8px', outline: 'none', width: '100%', boxSizing: 'border-box',
  };

  return (
    <div style={{ padding: 14, background: '#0d0d0d', borderRadius: 10, border: '1px dashed #2a2a2a', marginTop: 6 }}>
      <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#ffd666', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 10 }}>
        Add new extra image
      </Text>
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <div style={{ width: 64, height: 80, flexShrink: 0, borderRadius: 7, background: '#111', border: '1px dashed #252525', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {preview && val.trim()
            ? <img src={val.trim()} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.currentTarget.style.display = 'none'; }} />
            : <span style={{ color: '#2a2a2a', fontSize: 22 }}>+</span>}
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 7, minWidth: 0 }}>
          <input value={label} onChange={e => setLabel(e.target.value)} placeholder="Label" style={inputStyle} />
          <input value={val} onChange={e => { setVal(e.target.value); setPreview(false); }}
            onKeyDown={e => { if (e.key === 'Enter') commit(); }}
            placeholder="URL or ./path.png" style={inputStyle} />
          {/* ── pick from uploads ── */}
          <UploadedImagesPicker
            activeUrl={val}
            onSelect={url => { setVal(url); setPreview(true); }}
          />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button onClick={() => setPreview(true)} disabled={!val.trim()}
              style={{ fontSize: 10, fontFamily: 'Space Mono, monospace', color: val.trim() ? '#ffd666' : '#2a2a2a', background: 'transparent', border: 'none', cursor: val.trim() ? 'pointer' : 'default', textDecoration: val.trim() ? 'underline dotted' : 'none', padding: 0 }}>
              Preview
            </button>
            <button onClick={commit} disabled={!val.trim()}
              style={{ padding: '4px 14px', borderRadius: 6, border: val.trim() ? '1px solid #ffd66666' : '1px solid #222', background: val.trim() ? '#ffd66618' : '#111', color: val.trim() ? '#ffd666' : '#333', fontFamily: 'Space Mono, monospace', fontSize: 11, cursor: val.trim() ? 'pointer' : 'default', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
              Add ↵
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── VisibilityToggle ──────────────────────────────────────────────────────
function VisibilityToggle({ hidden, onToggle, label, color }) {
  return (
    <button
      onClick={onToggle}
      title={hidden ? `Show ${label}` : `Hide ${label}`}
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '5px 12px', borderRadius: 8,
        border: `1px solid ${hidden ? '#2a2a2a' : color + '55'}`,
        background: hidden ? '#111' : color + '14',
        cursor: 'pointer', transition: 'all 0.18s ease',
        fontFamily: 'Space Mono, monospace', fontSize: 11,
        letterSpacing: '0.08em', color: hidden ? '#444' : color,
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ fontSize: 13, lineHeight: 1 }}>{hidden ? '🚫' : '✓'}</span>
      <span>{hidden ? 'Hidden' : 'Visible'}</span>
    </button>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Main page
// ═══════════════════════════════════════════════════════════════════════════
export default function ImageControlPage() {
  const [cfg, setCfg] = useState({ ...DEFAULTS });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [tab, setTab] = useState('Text');
  const [previewProgress, setPreviewProgress] = useState(50);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    (async () => {
      try {
        const remote = await loadConfig();
        if (remote) {
          setCfg(prev => ({
            ...prev, ...remote,
            extraImages: safeArray(remote.extraImages).map(mergeExtra),
          }));
        }
      } catch { message.warning('Could not load config — using defaults'); }
      finally { setLoading(false); }
    })();
  }, []);

  const set = useCallback((key, val) => {
    setCfg(prev => ({ ...prev, [key]: val }));
    setDirty(true);
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await saveConfig(cfg);
      message.success('Config saved to Firestore ✓');
      setDirty(false);
    } catch (e) { message.error(`Save failed: ${e.message}`); }
    finally { setSaving(false); }
  };

  const handleReset = () => {
    setCfg({ ...DEFAULTS });
    setDirty(true);
    message.info('Reset to defaults — press Save to persist');
  };

  const extraImages = safeArray(cfg.extraImages).map(mergeExtra);

  const updateExtra = (idx, updated) => {
    const next = [...extraImages];
    next[idx] = updated;
    set('extraImages', next);
  };
  const removeExtra = (idx) => {
    const next = [...extraImages];
    next.splice(idx, 1);
    set('extraImages', next);
  };
  const moveExtra = (idx, dir) => {
    const next = [...extraImages];
    const target = idx + dir;
    if (target < 0 || target >= next.length) return;
    [next[idx], next[target]] = [next[target], next[idx]];
    set('extraImages', next);
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300 }}>
      <Spin size="large" />
    </div>
  );

  const rotCurveNote = (
    <div style={{ marginBottom: 12, padding: '10px 14px', background: '#0a0a0a', borderRadius: 8, border: '1px solid #1a1a1a' }}>
      <Text style={{ fontSize: 11, color: '#444', fontFamily: 'Space Mono, monospace', lineHeight: 1.8, display: 'block' }}>
        Rotation curve: 3 segments — <span style={{ color: '#86efac' }}>rotStart → rotAtA</span> (0 to pA), <span style={{ color: '#86efac' }}>rotAtA → rotAtB</span> (pA to pB), then held.<br />
        <span style={{ color: '#333' }}>Set pA = pB = 0 to disable and use simple linear lerp.</span>
      </Text>
    </div>
  );

  return (
    <div style={{
      maxWidth: 820,
      margin: '0 auto',
      padding: isMobile ? '12px 10px 80px' : '0 0 48px',
    }}>

      {/* ── Header ── */}
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: isMobile ? 'flex-start' : 'center',
        marginBottom: 20, flexWrap: 'wrap', gap: 10,
      }}>
        <div>
          <Title level={isMobile ? 5 : 4} style={{ margin: 0, color: '#f0ece4' }}>
            Image + Text Controller
          </Title>
          <Text style={{ color: '#555', fontSize: 11, fontFamily: 'Space Mono, monospace' }}>
            Tools section — animation &amp; content config
          </Text>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {dirty && !isMobile && <Tag color="warning" style={{ fontFamily: 'Space Mono, monospace', fontSize: 11 }}>Unsaved</Tag>}
          <Button size={isMobile ? 'small' : 'middle'} icon={<ReloadOutlined />} onClick={handleReset}
            style={{ background: '#111', border: '1px solid #333', color: '#aaa' }}>
            {isMobile ? '' : 'Reset'}
          </Button>
          <Button type="primary" size={isMobile ? 'small' : 'middle'} icon={<SaveOutlined />}
            onClick={handleSave} loading={saving} disabled={!dirty}
            style={{ background: dirty ? '#c8f04a' : '#1a1a1a', border: 'none', color: dirty ? '#000' : '#444', fontWeight: 700 }}>
            {isMobile ? 'Save' : 'Save to Firestore'}
          </Button>
        </div>
      </div>

      {/* ── Motion preview ── */}
      <MotionPreview cfg={cfg} progress={previewProgress / 100} extraImages={extraImages} />
      <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10 }}>
        <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#555', whiteSpace: 'nowrap', flexShrink: 0 }}>
          {isMobile ? 'Scroll' : 'Preview scroll'}
        </Text>
        <Slider min={0} max={100} value={previewProgress} onChange={setPreviewProgress} style={{ flex: 1 }}
          styles={{ track: { background: '#c8f04a' }, handle: { borderColor: '#c8f04a' } }} />
        <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#c8f04a', minWidth: 30, textAlign: 'right' }}>
          {previewProgress}%
        </Text>
      </div>

      {/* ── Tabs ── */}
      <TabBar active={tab} onChange={setTab} isMobile={isMobile} />

      {/* ══ TEXT TAB ══ */}
      {tab === 'Text' && (
        <>
          <Section label="Overline" icon="✦" color="#ffd666">
            <TextInput isMobile={isMobile} label="Overline text" hint="Small label above heading"
              value={cfg.textOverline ?? DEFAULTS.textOverline} onChange={v => set('textOverline', v)} placeholder="Philosophy" />
          </Section>
          <Section label="Heading lines" icon="H" color="#ffd666">
            <TextInput isMobile={isMobile} label="Line 1" value={cfg.textLine1 ?? DEFAULTS.textLine1} onChange={v => set('textLine1', v)} placeholder="Craft over" />
            <ColorField isMobile={isMobile} label="Line 1 color" value={cfg.textLine1Color ?? DEFAULTS.textLine1Color} onChange={v => set('textLine1Color', v)} />
            <Divider style={{ borderColor: '#1e1e1e', margin: '6px 0' }} />
            <TextInput isMobile={isMobile} label="Line 2" value={cfg.textLine2 ?? DEFAULTS.textLine2} onChange={v => set('textLine2', v)} placeholder="shortcuts." />
            <ColorField isMobile={isMobile} label="Line 2 color" value={cfg.textLine2Color ?? DEFAULTS.textLine2Color} onChange={v => set('textLine2Color', v)} />
            <Divider style={{ borderColor: '#1e1e1e', margin: '6px 0' }} />
            <TextInput isMobile={isMobile} label="Line 3" value={cfg.textLine3 ?? DEFAULTS.textLine3} onChange={v => set('textLine3', v)} placeholder="Always." />
            <ColorField isMobile={isMobile} label="Line 3 color" value={cfg.textLine3Color ?? DEFAULTS.textLine3Color} onChange={v => set('textLine3Color', v)} />
          </Section>
          <Section label="Sub paragraph" icon="¶" color="#ffd666">
            <div style={{ marginBottom: 10 }}>
              {isMobile && <Text style={{ fontSize: 11, color: '#aaa', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 6 }}>Body text</Text>}
              <textarea
                value={cfg.textSub ?? DEFAULTS.textSub}
                onChange={e => set('textSub', e.target.value)}
                rows={4}
                style={{
                  background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: 6,
                  color: '#f0ece4', fontFamily: 'Syne, sans-serif', fontSize: 13, lineHeight: 1.7,
                  padding: '8px 10px', outline: 'none', resize: 'vertical',
                  width: '100%', boxSizing: 'border-box',
                }}
              />
            </div>
          </Section>
          <div style={{ background: '#000', border: '1px solid #1a1a1a', borderRadius: 12, padding: isMobile ? '16px' : '24px', textAlign: 'center' }}>
            <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.72rem', color: '#c8f04a', letterSpacing: '0.28em', textTransform: 'uppercase', marginBottom: '0.8rem' }}>{cfg.textOverline}</div>
            {[
              [cfg.textLine1, cfg.textLine1Color],
              [cfg.textLine2, cfg.textLine2Color],
              [cfg.textLine3, cfg.textLine3Color],
            ].map(([line, col], i) => (
              <div key={i} style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: isMobile ? 'clamp(1.4rem, 8vw, 2rem)' : 'clamp(1.8rem, 5vw, 3rem)', lineHeight: 1, letterSpacing: '-0.04em', color: col, marginBottom: i < 2 ? '0.08em' : '1rem' }}>
                {line}
              </div>
            ))}
            <p style={{ fontFamily: 'Syne, sans-serif', fontSize: isMobile ? '0.82rem' : '0.9rem', color: '#666', lineHeight: 1.85, maxWidth: '52ch', margin: '0 auto' }}>{cfg.textSub}</p>
          </div>
        </>
      )}

      {/* ══ DESKTOP TAB ══ */}
      {tab === 'Desktop' && (
        <>
          <Section label="Image 1 — Start (desktop)" icon="↙" color="#c8f04a">
            <SliderField isMobile={isMobile} label="Start X" hint="vw from left" value={cfg.img1StartX_desktop} onChange={v => set('img1StartX_desktop', v)} min={-100} max={100} unit="vw" />
            <SliderField isMobile={isMobile} label="Start Y" hint="vh from top"  value={cfg.img1StartY_desktop} onChange={v => set('img1StartY_desktop', v)} min={-100} max={150} unit="vh" />
            <SliderField isMobile={isMobile} label="Start rotation" value={cfg.img1StartRot} onChange={v => set('img1StartRot', v)} min={-90} max={90} unit="°" />
          </Section>
          <Section label="Image 1 — End (desktop)" icon="↗" color="#c8f04a">
            <SliderField isMobile={isMobile} label="End X" value={cfg.img1EndX_desktop} onChange={v => set('img1EndX_desktop', v)} min={-100} max={200} unit="vw" />
            <SliderField isMobile={isMobile} label="End Y" value={cfg.img1EndY_desktop} onChange={v => set('img1EndY_desktop', v)} min={-200} max={100} unit="vh" />
            <SliderField isMobile={isMobile} label="End rotation" value={cfg.img1EndRot} onChange={v => set('img1EndRot', v)} min={-90} max={90} unit="°" />
          </Section>
          <Section label="Image sizes (desktop)" icon="⊡" color="#c8f04a">
            <SliderField isMobile={isMobile} label="Image 1 width" value={cfg.img1Width_desktop} onChange={v => set('img1Width_desktop', v)} min={5} max={60} unit="vw" />
            <SliderField isMobile={isMobile} label="Image 2 width" value={cfg.img2Width_desktop} onChange={v => set('img2Width_desktop', v)} min={5} max={60} unit="vw" />
          </Section>
        </>
      )}

      {/* ══ MOBILE TAB ══ */}
      {tab === 'Mobile' && (
        <>
          <Section label="Image 1 — Start (mobile)" icon="↙" color="#00e5ff">
            <SliderField isMobile={isMobile} label="Start X" value={cfg.img1StartX_mobile} onChange={v => set('img1StartX_mobile', v)} min={-100} max={100} unit="vw" />
            <SliderField isMobile={isMobile} label="Start Y" value={cfg.img1StartY_mobile} onChange={v => set('img1StartY_mobile', v)} min={-100} max={150} unit="vh" />
          </Section>
          <Section label="Image 1 — End (mobile)" icon="↗" color="#00e5ff">
            <SliderField isMobile={isMobile} label="End X" value={cfg.img1EndX_mobile} onChange={v => set('img1EndX_mobile', v)} min={-100} max={200} unit="vw" />
            <SliderField isMobile={isMobile} label="End Y" value={cfg.img1EndY_mobile} onChange={v => set('img1EndY_mobile', v)} min={-200} max={100} unit="vh" />
          </Section>
          <Section label="Image sizes (mobile)" icon="⊡" color="#00e5ff">
            <SliderField isMobile={isMobile} label="Image 1 width" value={cfg.img1Width_mobile} onChange={v => set('img1Width_mobile', v)} min={5} max={80} unit="vw" />
            <SliderField isMobile={isMobile} label="Image 2 width" value={cfg.img2Width_mobile} onChange={v => set('img2Width_mobile', v)} min={5} max={80} unit="vw" />
          </Section>
        </>
      )}

      {/* ══ IMAGE 1 CURVE TAB ══ */}
      {tab === 'Image 1 Curve' && (
        <>
          {rotCurveNote}
          <Section label="Rotation curve — desktop" icon="⤾" color="#86efac">
            <SliderField isMobile={isMobile} label="Point A (pA)" hint="Segment 1 end" value={cfg.img1pA_desktop} onChange={v => set('img1pA_desktop', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Point B (pB)" hint="Segment 2 end" value={cfg.img1pB_desktop} onChange={v => set('img1pB_desktop', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.img1RotAtA_desktop} onChange={v => set('img1RotAtA_desktop', v)} min={-180} max={180} unit="°" />
            <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.img1RotAtB_desktop} onChange={v => set('img1RotAtB_desktop', v)} min={-180} max={180} unit="°" />
          </Section>
          <Section label="Rotation curve — mobile" icon="⤾" color="#86efac">
            <SliderField isMobile={isMobile} label="Point A (pA)" value={cfg.img1pA_mobile} onChange={v => set('img1pA_mobile', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Point B (pB)" value={cfg.img1pB_mobile} onChange={v => set('img1pB_mobile', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.img1RotAtA_mobile} onChange={v => set('img1RotAtA_mobile', v)} min={-180} max={180} unit="°" />
            <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.img1RotAtB_mobile} onChange={v => set('img1RotAtB_mobile', v)} min={-180} max={180} unit="°" />
          </Section>
        </>
      )}

      {/* ══ IMAGE 2 TAB ══ */}
      {tab === 'Image 2' && (
        <>
          <Section label="Trail & follow delay" icon="👣" color="#a78bfa">
            <SliderField isMobile={isMobile} label="Trail distance" hint="0 = sync with img1" value={cfg.trail} onChange={v => set('trail', v)} min={0} max={0.95} step={0.01} />
            <SliderField isMobile={isMobile} label="Fade-in window" hint="Fraction of img2 progress to fade" value={cfg.img2FadeStart} onChange={v => set('img2FadeStart', v)} min={0.01} max={0.5} step={0.01} />
            <SliderField isMobile={isMobile} label="Init rotation offset" hint="Extra offset on img2 at start" value={cfg.rot2InitOffset} onChange={v => set('rot2InitOffset', v)} min={-90} max={90} unit="°" />
          </Section>
          {rotCurveNote}
          <Section label="Rotation curve — desktop" icon="⤾" color="#a78bfa">
            <SliderField isMobile={isMobile} label="Point A (pA)" value={cfg.pA_desktop} onChange={v => set('pA_desktop', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Point B (pB)" value={cfg.pB_desktop} onChange={v => set('pB_desktop', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.rot2AtA_desktop} onChange={v => set('rot2AtA_desktop', v)} min={-180} max={180} unit="°" />
            <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.rot2AtB_desktop} onChange={v => set('rot2AtB_desktop', v)} min={-180} max={180} unit="°" />
          </Section>
          <Section label="Rotation curve — mobile" icon="⤾" color="#a78bfa">
            <SliderField isMobile={isMobile} label="Point A (pA)" value={cfg.pA_mobile} onChange={v => set('pA_mobile', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Point B (pB)" value={cfg.pB_mobile} onChange={v => set('pB_mobile', v)} min={0} max={1} step={0.01} />
            <SliderField isMobile={isMobile} label="Rotation at A" value={cfg.rot2AtA_mobile} onChange={v => set('rot2AtA_mobile', v)} min={-180} max={180} unit="°" />
            <SliderField isMobile={isMobile} label="Rotation at B" value={cfg.rot2AtB_mobile} onChange={v => set('rot2AtB_mobile', v)} min={-180} max={180} unit="°" />
          </Section>
        </>
      )}

      {/* ══ EXTRA IMAGES TAB ══ */}
      {tab === 'Extra Images' && (
        <>
          <div style={{ marginBottom: 12, padding: '10px 14px', background: '#111', borderRadius: 8, border: '1px solid #1e1e1e' }}>
            <Text style={{ fontFamily: 'Space Mono, monospace', fontSize: 11, color: '#555', lineHeight: 1.8, display: 'block' }}>
              Each extra image has independent position, trail, fade, rotation curve, size, z-index &amp; visibility.<br />
              Open ⚙ to configure. <span style={{ color: '#c8f04a' }}>✓</span> = visible. <span style={{ color: '#444' }}>👁</span> = hidden.
            </Text>
          </div>
          {extraImages.length === 0 && (
            <div style={{ padding: 24, textAlign: 'center', color: '#2a2a2a', fontFamily: 'Space Mono, monospace', fontSize: 11, border: '1px dashed #222', borderRadius: 10, marginBottom: 14 }}>
              No extra images yet — add one below
            </div>
          )}
          {extraImages.map((ex, idx) => (
            <ExtraImageEditor key={idx} ex={ex} idx={idx} total={extraImages.length}
              onChange={updated => updateExtra(idx, updated)}
              onRemove={() => removeExtra(idx)}
              onMove={(i, dir) => moveExtra(i, dir)} />
          ))}
          <AddExtraImageRow onAdd={newEx => set('extraImages', [...extraImages, newEx])} />
          {extraImages.length > 0 && (
            <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
              <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#555' }}>
                {extraImages.filter(e => !e.hidden).length} visible / {extraImages.length} total
              </span>
              <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#fb923c', background: '#fb923c14', border: '1px solid #fb923c28', borderRadius: 4, padding: '3px 10px' }}>
                {extraImages.length} extra image{extraImages.length !== 1 ? 's' : ''}
              </span>
            </div>
          )}
        </>
      )}

      {/* ══ GENERAL TAB ══ */}
      {tab === 'General' && (
        <>
          <Section label="Scroll pin duration" icon="📌" color="#ff6b6b">
            <SliderField isMobile={isMobile} label="Pin length" hint="% of viewport height" value={cfg.pinLength} onChange={v => set('pinLength', v)} min={100} max={500} unit="vh%" step={10} />
          </Section>

          <Section label="Core image URLs & visibility" icon="🖼" color="#ff6b6b">
            {[
              { key: 'img1Url', hiddenKey: 'img1Hidden', label: 'IMG 1 — leads', color: '#c8f04a', placeholder: './rock-bg.png' },
              { key: 'img2Url', hiddenKey: 'img2Hidden', label: 'IMG 2 — trails', color: '#a78bfa', placeholder: './miss.png' },
            ].map(({ key, hiddenKey, label, color, placeholder }) => {
              const isHidden = cfg[hiddenKey] ?? false;
              return (
                <div key={key} style={{
                  display: 'flex', gap: 12, alignItems: 'flex-start',
                  marginBottom: 14, padding: 12,
                  background: '#0a0a0a', borderRadius: 10,
                  border: `1px solid ${isHidden ? '#1e1e1e' : color + '33'}`,
                  opacity: isHidden ? 0.6 : 1,
                  transition: 'all 0.2s ease',
                }}>
                  {/* Thumbnail */}
                  <div style={{
                    width: 64, height: 80, flexShrink: 0, borderRadius: 8,
                    background: '#181818', border: '1px solid #2a2a2a',
                    overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    position: 'relative',
                  }}>
                    {cfg[key] ? (
                      <img src={cfg[key]} alt="" style={{
                        width: '100%', height: '100%', objectFit: 'cover',
                        filter: isHidden ? 'grayscale(1) brightness(0.4)' : 'none',
                        transition: 'filter 0.2s',
                      }} onError={e => { e.currentTarget.style.display = 'none'; }} />
                    ) : null}
                    {isHidden && (
                      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)' }}>
                        <span style={{ fontSize: 18 }}>🚫</span>
                      </div>
                    )}
                  </div>

                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                      <div style={{ padding: '2px 8px', borderRadius: 4, background: color + '22', border: `1px solid ${color}44`, fontFamily: 'Space Mono, monospace', fontSize: 10, color, letterSpacing: '0.14em', textTransform: 'uppercase' }}>
                        {label}
                      </div>
                      <VisibilityToggle hidden={isHidden} onToggle={() => set(hiddenKey, !isHidden)} label={label} color={color} />
                    </div>
                    <input
                      value={cfg[key]}
                      onChange={e => set(key, e.target.value)}
                      placeholder={placeholder}
                      style={{ background: '#111', border: '1px solid #2a2a2a', borderRadius: 6, color: '#f0ece4', fontFamily: 'Space Mono, monospace', fontSize: 11, padding: '7px 10px', outline: 'none', width: '100%', boxSizing: 'border-box' }}
                    />
                    {/* ── Uploaded images picker ── */}
                    <UploadedImagesPicker
                      activeUrl={cfg[key]}
                      onSelect={url => set(key, url)}
                    />
                    {isHidden && (
                      <div style={{ fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#444', background: '#111', borderRadius: 5, padding: '4px 8px', border: '1px solid #1e1e1e' }}>
                        ⚠ Not rendered on the portfolio frontend
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </Section>

          <Section label="Config export" icon="📋" color="#ff6b6b">
            <Text style={{ fontSize: 11, color: '#555', fontFamily: 'Space Mono, monospace', display: 'block', marginBottom: 10 }}>
              Copy into Tools.jsx to hard-code values (bypasses Firestore).
            </Text>
            <div style={{ background: '#0a0a0a', border: '1px solid #1a1a1a', borderRadius: 8, padding: '12px 14px', fontFamily: 'Space Mono, monospace', fontSize: 10, color: '#c8f04a', lineHeight: 1.7, overflowX: 'auto', maxHeight: 260, overflowY: 'auto' }}>
              <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                {JSON.stringify(cfg, null, 2)}
              </pre>
            </div>
            <Button size="small" style={{ marginTop: 10, background: '#111', border: '1px solid #333', color: '#aaa' }}
              onClick={() => { navigator.clipboard.writeText(JSON.stringify(cfg, null, 2)); message.success('Copied to clipboard'); }}>
              Copy JSON
            </Button>
          </Section>
        </>
      )}

      {/* ── Sticky save bar ── */}
      {dirty && (
        <div style={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10,
          padding: isMobile ? '10px 14px' : '12px 24px',
          background: '#0d0d0d', border: '1px solid #c8f04a33',
          borderBottom: 'none', borderLeft: 'none', borderRight: 'none',
          zIndex: 100, backdropFilter: 'blur(8px)',
        }}>
          <Text style={{ flex: 1, fontFamily: 'Space Mono, monospace', fontSize: isMobile ? 10 : 11, color: '#c8f04a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            ● Unsaved changes
          </Text>
          <Button size={isMobile ? 'small' : 'middle'} onClick={handleReset}
            style={{ background: '#111', border: '1px solid #333', color: '#aaa', flexShrink: 0 }}>
            Discard
          </Button>
          <Button type="primary" size={isMobile ? 'small' : 'middle'} icon={<SaveOutlined />}
            onClick={handleSave} loading={saving}
            style={{ background: '#c8f04a', border: 'none', color: '#000', fontWeight: 700, flexShrink: 0 }}>
            {isMobile ? 'Save' : 'Save to Firestore'}
          </Button>
        </div>
      )}
    </div>
  );
}